import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { SwPush } from '@angular/service-worker';
import { firstValueFrom, interval, takeWhile } from 'rxjs';
import { environment } from '../../../environments/environment';
import { currentTheme, isLargeScreen } from '../../../global.variable';
import {
  appUserMenu,
  MENU_ITEMS,
  MENU_SETTINGS_ITEMS,
  superUserMenu,
} from '../../../sidebar-user-menu';
import { AppService } from '../../app.service';
import { UserProfileService } from '../../profile/user-profile/user-profile.service';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { FileUploadComponent } from '../../shared/components/file-upload/file-upload.component';
import { ModalDialogueService } from '../../shared/components/modal-dialogue/modal-dialogue.service';
import { MultipleAccountsComponent } from '../../shared/components/multiple-accounts/multiple-accounts.component';
import { QueuedEventsComponent } from '../../shared/components/queued-events/queued-events.component';
import { ScreenshotGuideComponent } from '../../shared/components/screenshot-guide/screenshot-guide.component';
import { SplashScreenComponent } from '../../shared/components/splash-screen/splash-screen.component';
import { WhatsNewComponent } from '../../shared/components/whats-new/whats-new.component';
import { DataCheckService } from '../../shared/services/data-check.service';
import { gTDB } from '../../shared/services/db';
import { DeviceInfoService } from '../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../shared/services/loading-spinner.service';
import { OrientationLockService } from '../../shared/services/orientationlock.service';
import { ToasterService } from '../../shared/services/toaster.service';
import { WebSocketService } from '../../shared/services/web-socket.service';

import { Capacitor } from '@capacitor/core';

import { AppChecksComponent } from '../../shared/components/app-checks/app-checks.component';
import { CheckpointService } from './checkpoints/checkpoint.service';
import { JobsService } from './jobs/jobs.service';
import { PagesService } from './pages.service';
import { UserPromptService } from './user-prompts/user-prompt.service';
import { SyncClockService } from '../../shared/services/sync-clock.service';
import { SqliteDbService } from '../../shared/services/sqlite-db.service';
import { NativeBgUploadService } from '../../shared/services/native-bg-upload.service';
declare var bootstrap: any;
declare var GuideChimp: any;
@Component({
  selector: 'gtapp-pages',
  templateUrl: './pages.component.html',
  styleUrl: './pages.component.scss',
  standalone: false,
})
export class PagesComponent implements OnInit, OnDestroy {
  currentTheme: any = currentTheme;

  sideBarMenuItems: any;
  sideBarMenuItemsBackup: any = [];

  loggedInUser: any = {};

  navbarToggled: boolean = false;

  settingItems: any = [];

  isSubscriptionActive: any;
  isAdmin: boolean = false;
  isDispatchUser: boolean = false;

  isGuardUser: any;
  isSubscriberAdmin: boolean = false;

  isSuperUser: boolean = false;
  userData: any;

  largeView: Boolean = isLargeScreen;
  // notification params
  notificationCount: any;
  unReadMessageCount: number = 0;
  notificationData: any = [];
  previous: number = 0;
  rows: number = 10;
  pageNum: number = 1;
  totalPages: number = 0;
  totalRows: number = 0;

  showWelfareCheck: any;
  welfareTempHoldValue: any;
  welfareCheckMissedReason: string = '';

  welfareCheckOfflineAlert: any = {};
  userMenu: any = appUserMenu;

  @ViewChild('menu') menu!: ElementRef;
  @ViewChild('audioRecordingTemplate') audioRecordingTemplate!: ElementRef;
  @ViewChild('clockInAndOutAdditionalInfoTemplate')
  clockInAndOutAdditionalInfoTemplate: any;

  @ViewChild('sideBarMenu') sideBarMenu!: ElementRef;

  windowScrolled: boolean = false;
  showUserDropdown: boolean = false;

  hasMultipleAccountsLinked: boolean = false;
  switchAccountDialogOpened: boolean = false;

  expandIcon: boolean = false;

  currentRoute: string = '';

  dialogRef: any;

  showManageMenu: boolean = false;

  isInBackgroundSync: boolean = false;
  isAppOnline: boolean = true;
  isOnEvent: boolean = false;
  offlineMode: boolean = false;
  messageChannel = new MessageChannel();

  dragging: boolean = false;
  intervalId: any;

  isPWAInstalled: boolean = true;
  deferredPWAInstallPrompt: any;

  isHomeComponent: boolean = false;
  allowedPaths: boolean = false;

  isOnlyGuardAndDispatcher: boolean = false;
  isPreviousSubscribed: boolean = false;

  feedbackForm = new FormGroup({
    feedback: new FormControl('', [
      Validators.required,
      Validators.maxLength(340),
    ]),
  });
  feedbackAttachment: any = {};
  notificationPermission: any;
  sosAlertCount: number = 0;
  beepIntervalSubscription: any;
  isAlertActive: boolean = false;
  permissionErrorStatus: any;
  // varaible to check how many days are left for the subscriber in the grace period
  isInGracePeriod: any = this.dataCheckService.isInGracePeriod();

  internetConnectionAvailable: boolean = navigator.onLine;

  guideChimp: any;
  onBoarding: any = {};
  guideIdMapping: any = {
    '/client': 'manageSite',
    '/siteList': 'manageSite',
    '/checkpoints': 'manageCheckpoint',
    '/jobs': 'manageAlarms',
    '/roster': 'manageRoster',
    '/users': 'manageGuard',
    '/dashboard': 'home',
    '/hand-over-log': 'manageHOL',
    '/reports': 'manageReports',
  };
  routeInsideRoot: boolean = true;
  rootLevelRoutes: any = [];
  // https://app.shortcut.com/sendem/story/11213/contextual-upper-left-button-refactor-back-button
  showBackBtn: boolean = false;

  isPhoneIOS = this.deviceInfoService.isPhoneIOS();
  iosSafariBrowser: boolean = false;
  guideChimpInterval: any;
  currentTourElement: string = '';
  guideItems: any = [];
  guideStyleOperationsNeeded: any = {};

  newSupportUpdate: boolean = false;

  appNewVersionAvailable: boolean = false;

  isSuperUserAccess = localStorage.getItem(btoa('superUserAccess')) === 'true';

  minSupportVersionDevice: any;

  showChatMessageIcon: boolean = false;
  existingSupportQueries: boolean = false;

  notificationCountTimeoutFn: any;
  loggedInDeviceID = this.deviceInfoService.getUniqueDeviceID();

  lateOREarlyClockOutData: any = {};

  nfcReaderAvailable: boolean = false;

  splashScreenOpened: boolean = false;

  subscriberStats: any;

  faqItemDict: any = {};
  showGettingStartedGuideOption: boolean = true;
  userCurrentDeviceDetail: any = {};

  updateUserPromptOnHomePage: boolean = false;
  syncUpdateCheck: any = {};

  // audio recording params
  isAudioRecording = false;

  recordingTime = 0;
  recordingTimerInterval: any;

  recordingBtnTimer: any;

  mediaRecorder!: MediaRecorder;
  speechRecognition: any;
  speechRecognitionText: string = '';
  audioChunks: Blob[] = [];

  audioFileData: any;

  audioContext!: AudioContext;
  audioRecordingAnalyser!: AnalyserNode;
  audioRecordingSource!: MediaStreamAudioSourceNode;
  audioRecordingDataArray: any;

  canvas!: HTMLCanvasElement;
  canvasCtx!: CanvasRenderingContext2D;

  animationId: any;

  recordingStarted: boolean = false;

  audioTemplateRef: any;
  audioSendBtnPressed: boolean = false;

  clockedInTimer: any;
  clockedInTimerFn: any;

  lastUsedRoutes: any = [];

  isNativeApp = Capacitor.isNativePlatform();

  isDeveloperMode = environment.devMode; // This is for adding refresh icon. It should not be there for production app.

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private profileService: UserProfileService,
    private spinnerService: LoadingSpinnerService,
    private pageService: PagesService,
    private dialogService: ModalDialogueService,
    private dataCheckService: DataCheckService,
    private ngZone: NgZone,
    private viewContainerRef: ViewContainerRef,
    private jobService: JobsService,
    private toasterService: ToasterService,
    private swPush: SwPush,
    private orientationLockService: OrientationLockService,
    private cdr: ChangeDetectorRef,
    private deviceInfoService: DeviceInfoService,
    private webSocketService: WebSocketService,
    private nativeUploadService: NativeBgUploadService,
    private clockService: SyncClockService,
    private sqliteDb: SqliteDbService,
  ) {
    // for users coming in from registration page, it will be reloaded after subscription by that time `theme` value will be written, so add to localStorage
    const isIOSFirstTimeUser =
      this.isPhoneIOS && !this.largeView && !('gtAppTheme' in localStorage);

    if (isIOSFirstTimeUser) {
      localStorage.setItem(btoa('isIOSFirstTimeUser'), 'true');
    }
    this.currentTheme = this.appService.getGTAppTheme();
    this.appService.switchGTAppTheme(this.currentTheme);
    this.checkPWAInstallable();

    this.router.events.subscribe((event: any) => {
      if (event.navigationTrigger === 'popstate') {
        // WHEN USER CLICK THE BACK BUTTON
        this.triggerCleanUp();
      }
      if (event instanceof NavigationStart) {
        // Show progress spinner or progress bar

        this.enableScrollOnBody();
        this.pageService.refreshToken().then((value: any) => {
          if (value) this.updateLoggedInUserDetail();
        });
      }

      if (event instanceof NavigationEnd) {
        const currentUrl = this.router.url.split('#');

        if (currentUrl?.length && currentUrl[0] != this.currentRoute) {
          this.currentRoute = currentUrl[0];
          this.triggerCleanUp();

          this.getNotificationCount();
          if (!this.largeView) this.clockService.maybeSync(5 * 60 * 1000); //  5 minute resync only for mobiles

          this.getSideBarBackIcon();

          window.scrollTo(0, 0);
        }

        this.isHomeComponent =
          event.urlAfterRedirects === '/dashboard' ||
          event.urlAfterRedirects === '/';
        this.allowedPaths = ['/profile', '/support', '/subscription'].includes(
          event.urlAfterRedirects,
        );
        this.isInGracePeriod = this.dataCheckService.isInGracePeriod();
        if (event.urlAfterRedirects === '/subscription') {
          this.isInGracePeriod = false;
        }
      }

      this.isSubscriptionActive =
        this.dataCheckService.checkIsSubscriptionOrTestUser();
    });

    this.windowScrolled = false;
    this.userData = this.appService.getUserData();
    this.isSuperUser = this.dataCheckService?.isSuperUser();
    this.isSubscriberAdmin = this.dataCheckService?.isSubscriberAdmin();
    this.isAdmin = this.dataCheckService?.isUserAdmin();
    this.isDispatchUser = this.dataCheckService?.isDispatchUser();
    this.isGuardUser = this.dataCheckService?.isGuardUser();
    this.isOnlyGuardAndDispatcher =
      (this.isGuardUser || this.isDispatchUser) && !this.isAdmin;

    this.isPreviousSubscribed =
      this.dataCheckService?.checkIsPreviouslySubscribedAndSubscriptionInActive();
    this.isSubscriptionActive =
      this.dataCheckService.checkIsSubscriptionOrTestUser();
  }
  @HostListener('document:pointerdown', ['$event'])
  onPointerDown(event: PointerEvent) {
    // close side bar if click or touch happens outside the sidebar
    const target = event.target;

    if (!(target instanceof Element)) {
      return;
    }

    if (
      this.navbarToggled &&
      !this.sideBarMenu.nativeElement.contains(target)
    ) {
      const sideBarIcon = document.getElementById('sidebar-menu');
      const homeLogo = document.getElementById('gt-logo-home');
      // make sure this excludes sandwich icon to avoid multiple toggles

      if (
        !sideBarIcon?.contains(target) &&
        !homeLogo?.contains(target) &&
        !target.closest('.gc-tooltip') // clicks inside guidechimp dialogbox
      )
        this.navbarToggled = false;
    }
  }
  ngOnDestroy(): void {
    window.removeEventListener(
      'beforeinstallprompt',
      this.beforeInstallPromptHandler,
    );
    if (this.clockedInTimerFn) clearInterval(this.clockedInTimerFn);
  }

  triggerCleanUp() {
    this.dialogService?.closeAll();

    this.dialogRef?.close();
    this.appService.removeToolTips();
  }
  goBack() {
    sessionStorage.removeItem('fromSite');
    if (this.showBackBtn) {
      this.showBackBtn = false;
      this.deviceInfoService.deviceInfoSubject.next({ goBack: true });
    } else {
      window.history.back();
    }
  }

  openChangeLog() {
    this.spinnerService.show();
    this.profileService.getVersionInfo().subscribe((response: any) => {
      if (response?.status == 'success') {
        this.spinnerService.hide();

        this.dialogRef = this.dialogService.open(WhatsNewComponent, {
          data: { latestVersion: response },
        });
      }
      this.spinnerService.hide();
    });
  }
  showSubscriptionOption(): boolean {
    if (this.isSubscriberAdmin) {
      if (this.dataCheckService.isFreeAccessAccount()) return false;
      if (this.dataCheckService.isTrialAccount()) return true;
      return true;
    }

    return false;
  }

  async arrangeUserMenu() {
    this.userMenu = appUserMenu;
    this.userMenu = this.userMenu?.filter((item: any) => {
      if (item.title === 'Subscription') {
        return Boolean(
          this.showSubscriptionOption() && this.checkPrevouslySubscribed(),
        );
      } else if (item.title === 'Edit Profile') {
        return this.checkPrevouslySubscribed();
      } else if (item.title === 'Support') {
        return this.checkPrevouslySubscribed();
      } else if (item.title === 'Change Log') {
        return this.checkPrevouslySubscribed();
      } else {
        return true;
      }
    });
    this.rootLevelRoutes = this.sideBarMenuItemsBackup?.map(
      (route: any) => route?.link,
    );

    const settingsRootLevelRoutes = this.settingItems?.map(
      (route: any) => route?.link,
    );

    if (settingsRootLevelRoutes?.length) {
      this.rootLevelRoutes = [
        ...this.rootLevelRoutes,
        ...settingsRootLevelRoutes,
      ];
    }
    this.getSideBarBackIcon();
  }
  conditionalUpdateSideBarMenuItems() {
    this.subscriberStats = this.getSubscriberStatsFromLS();
    const uniqueUserCount =
      this.pageService.getGroupUserCount('unique_user_count');

    this.showChatMessageIcon =
      uniqueUserCount > 1 ||
      this.subscriberStats?.in_app_message_exist ||
      this.subscriberStats?.users_exist;

    this.sideBarMenuItems = this.sideBarMenuItemsBackup?.filter(
      (menuItem: any) => {
        if (menuItem?.link === '/sos-welfare-alerts') {
          return (
            uniqueUserCount > 1 ||
            this.subscriberStats?.sos_alert_exists ||
            this.subscriberStats?.missed_welfare_check_exists
          );
        }
        if (menuItem?.link === '/hand-over-log') {
          return uniqueUserCount > 1 || this.subscriberStats?.hol_exists;
        }
        if (menuItem?.link === '/message') {
          return (
            uniqueUserCount > 1 || this.subscriberStats?.in_app_message_exists
          );
        }

        return true;
      },
    );
  }
  getSideBarBackIcon() {
    this.routeInsideRoot =
      this.rootLevelRoutes?.includes(this.currentRoute) ||
      this.currentRoute === '/' ||
      this.currentRoute === '/dashboard';
  }
  async getSideBar(routeToHome = false) {
    this.spinnerService.show();

    this.profileService
      .getUserConfig({
        remember_login: 1,
        time_offset: new Date().getTimezoneOffset(),
      })
      .subscribe((resp: any) => {
        if (resp['status'] == 'success') {
          this.sideBarMenuItems = resp?.data || [];
          if (this.sideBarMenuItems?.length === 0) {
            this.sideBarMenuItems = MENU_ITEMS;
          }
          this.settingItems = this.isAdmin ? MENU_SETTINGS_ITEMS : [];

          let permissionToken = resp?.user_permission_token;
          let userData = this.appService.getUserData();
          if (permissionToken) {
            userData.user_token = permissionToken;
          }
          this.appService.setUserData(userData);

          if (resp?.app_route_config) {
            localStorage.setItem(
              btoa('appRoutesConfig'),
              resp?.app_route_config,
            );
          }

          this.hasMultipleAccountsLinked = Boolean(
            resp?.has_other_associated_accounts ||
            (
              JSON.parse(
                localStorage.getItem(btoa('userLinkedAccountTokens')) || '[]',
              ) || []
            )?.length > 1,
          );

          this.isSubscriptionActive =
            this.dataCheckService.checkIsSubscriptionOrTestUser();

          if (routeToHome) this.router.navigate(['/']);

          if (this.isSubscriberAdmin && !this.isSubscriptionActive) {
            this.router.navigate([
              '/subscription',
              {
                state: 'Account Verified! Subscription Required',
              },
            ]);
          }
        }
        // for checking 404
        this.sideBarMenuItemsBackup = Object.freeze(this.sideBarMenuItems);

        this.spinnerService.hide();
        this.arrangeUserMenu();
        this.conditionalUpdateSideBarMenuItems();
      });
  }
  checkWelfareChecks() {
    if (!this.isOnEvent && this.welfareTempHoldValue?.welfare_check_id) {
      this.showWelfareCheck = this.welfareTempHoldValue;
    }
  }
  isServerOnline() {
    return new Promise((resolve) => {
      try {
        this.appService.checkServerStatus().subscribe({
          next: (response: any) => {
            resolve(response?.status === 'success');
          },
          error: (err) => {
            resolve(false);
          },
        });
      } catch (error) {
        resolve(false);
      }
    });
  }

  async checkServerAndSync() {
    if (this.offlineMode && navigator.onLine) {
      const isServerOnlineVar = await this.isServerOnline();
      if (isServerOnlineVar) {
        this.isAppOnline = true;
        this.offlineMode = !this.isAppOnline;
        this.deviceInfoService.deviceInfoSubject.next({ appStatus: true });
        localStorage.setItem('syncData', 'true');
      }
    }
    setTimeout(() => {
      if (
        this.isAppOnline &&
        this.isHomeComponent &&
        !this.isOnEvent &&
        navigator.onLine &&
        localStorage.getItem('syncData') === 'true'
      ) {
        window.location.reload();
      }
    }, 1000);
  }

  async checkOnlineOffline(isAppOnline: boolean = true) {
    // if the user is not on middle of the update reload the page when the device comes back online

    this.isAppOnline = isAppOnline;
    this.offlineMode = !this.isAppOnline;

    this.checkServerAndSync();
    this.appService.initializeBootstrapTooltips();
    setTimeout(() => {
      this.checkServerAndSync();
    }, 5000);

    if (this.offlineMode && !this.isOnEvent && !this.isHomeComponent) {
      this.ngZone.run(() => {
        setTimeout(() => {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: `Unable to connect to server, operating in offline mode.`,
          });
        }, 100);

        setTimeout(() => {
          this.router.navigate(['/']);
        }, 3000);
      });
    }
  }
  syncQueuedData() {
    setTimeout(() => {
      if (!this.isInBackgroundSync) {
        this.isInBackgroundSync = true;

        if (this.swPush.isEnabled)
          // ask the service worker to start sync
          navigator?.serviceWorker?.controller?.postMessage({
            type: 'syncData',
          });
        if (this.isNativeApp) this.nativeUploadService.syncIfOnline();

        // send a fallbackcheck to see background sync is complete
        setTimeout(() => {
          this.fallBackCheck();
        }, 2000);
      }
    }, 100);
  }
  fallBackCheck() {
    /// a delayed to check whether the background sync is over or not
    if (this.isInBackgroundSync) {
      navigator?.serviceWorker?.controller?.postMessage({
        type: 'syncDataCheck',
      });
    }
  }
  serviceWorkerOperations() {
    navigator?.serviceWorker?.controller?.postMessage(
      {
        type: 'INIT_PAGES_PORT',
      },
      [this.messageChannel.port2],
    );

    navigator?.serviceWorker?.addEventListener('message', (event) => {
      if (event?.data?.type === 'syncDataCheck') {
        if (this.isInBackgroundSync) {
          if (event?.data?.syncInProgress) {
            setTimeout(() => {
              this.fallBackCheck();
            }, 5000);
          } else {
            this.deviceInfoService.deviceInfoSubject.next({
              syncComplete: true,
            });
            this.spinnerService.hide();
            this.isInBackgroundSync = false;
          }
        }
      }
    });

    // Listen to the response
    this.messageChannel.port1.onmessage = (event) => {
      if (event?.data?.type === 'syncComplete') {
        if (this.isInBackgroundSync) {
          this.deviceInfoService.deviceInfoSubject.next({
            syncComplete: true,
          });
          this.spinnerService.hide();
          this.isInBackgroundSync = false;
        }
      }

      if (
        event?.data?.type === 'welfareCheckAlert' &&
        !this.isAppOnline &&
        !this.welfareTempHoldValue?.welfare_check_id &&
        !this.showWelfareCheck?.welfare_check_id
      ) {
        this.welfareCheckOfflineAlert = event?.data;
        this.cdr.detectChanges();
      }

      if (event?.data?.message) {
        this.ngZone.run(() => {
          this.deviceInfoService.deviceInfoSubject.next({
            syncItemsInDb: true,
          });
          if (!this.isInBackgroundSync && event?.data?.qr_cp) {
            if (event?.data?.status === 'failure') {
              this.toasterService.setMessage({
                failureCross: true,
              });
              // this.toasterService.setMessage({
              //   errorMessage: event?.data?.message,
              //   successMessage: '',
              // });
              // } else {
              //   this.toasterService.setMessage({
              //     successMessage: event?.data?.message,
              //     errorMessage: '',
              //   });
            }
          }
        });
      }
    };

    if (localStorage.getItem('syncData') === 'true' && !this.offlineMode) {
      localStorage.removeItem('syncData');
      this.syncQueuedData();
    }

    this.appService.updateGuardTrackerApp();
  }
  browserMinVersionCheck() {
    this.appService
      .getMinVersionCheckDevice()
      .then((value: any) => (this.minSupportVersionDevice = value));
  }

  async ngOnInit() {
    this.clockService.sync();
    this.sqliteDb.resetCurrentSubscriberUserId();
    this.browserMinVersionCheck();
    let scrollTimeout: any;

    // window.addEventListener('touchend', () => {
    //   this.windowScrolled = window.scrollY > 100;
    //   clearTimeout(scrollTimeout);
    //   scrollTimeout = setTimeout(() => {
    //     this.windowScrolled = false;
    //     clearTimeout(scrollTimeout);
    //   }, 3000);
    // });
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      const isScrollingUp = currentScrollY < lastScrollY;
      const showThreshold = 100;
      if ('ontouchstart' in window) {
        this.windowScrolled = isScrollingUp && currentScrollY > showThreshold;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          this.windowScrolled = false;
        }, 2000);
      }

      lastScrollY = currentScrollY;
    });

    if (this.isSuperUser !== true && this.userData?.access) {
      await this.getSideBar();
    }

    if (this.isPhoneIOS) {
      const isDevicePWA = this.deviceInfoService.isDevicePWA();

      const currentDeviceInfo: any =
        await this.deviceInfoService.getDeviceInfo();
      this.iosSafariBrowser =
        currentDeviceInfo?.browser == 'Safari' && !isDevicePWA;

      document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
      });

      document.addEventListener('gesturechange', function (e) {
        e.preventDefault();
      });
      document.addEventListener('gestureend', function (e) {
        e.preventDefault();
      });
    } else {
      document.addEventListener('touchstart', function (e) {
        document.body.style.touchAction = 'manipulation';
      });
    }
    if (!this.loggedInDeviceID) {
      this.loggedInDeviceID = this.deviceInfoService.getUniqueDeviceID();
    }
    this.webSocketService.webSocketSubject.subscribe((event: any) => {
      const webSocketSourceDevice =
        event?.request_user?.logged_in_device_id || event?.logged_in_device_id;
      // if the source is the same device no need to trigger anything for that
      if (webSocketSourceDevice == this.loggedInDeviceID) return;
      // some ws communication are meant for individaul pages, they dont need to be used here. Just avoid them also
      if (
        [
          'wsn_individual_chat',
          'wsn_chat_delete',
          'update_read_messages',
          'wsn_delete_group_chat',
          'wsn_group_chat',
          'individual_job_update',
          'individual_incident_update',
        ].includes(event?.event)
      )
        return;

      if (['wsn_subscription_change'].includes(event?.event)) {
        this.getSideBar(true);
      }
      if (['wsn_user_prompt_updates'].includes(event?.event)) {
        this.updateUserPromptOnHomePage = true;
      }
      if (['wsn_individual_cp_update'].includes(event?.event)) {
        this.jobService
          .getNearestCheckpointList()
          .subscribe((response: any) => {});
      }

      if (['wsn_chat_notification'].includes(event?.event)) {
        if (this.currentRoute !== '/message') {
          this.getNotificationCount();
          if (event?.message) {
            this.toasterService.setMessage({
              successMessage: event['message'],
              errorMessage: '',
            });
          }
        }
      } else {
        if (event?.message) {
          if (event?.message_style == 'danger') {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: event['message'],
            });
          } else {
            this.toasterService.setMessage({
              successMessage: event['message'],
              errorMessage: '',
            });
          }
        }
        this.getNotificationCount();
      }

      if (event?.event === 'hol') {
        sessionStorage.setItem('handOverLogUpdate', '1');
      }
    });

    this.pageService.miscSubjectParam.subscribe((value: any) => {
      if (value?.showGettingStartedGuide) {
        this.showGettingStartedGuideOption = false;
      }
      if ('startGuide' in value) {
        //https://app.shortcut.com/sendem/story/10805/first-time-user-changes#activity-10834
        if (value?.startGuide === 'hideGetStarted')
          this.showGettingStartedGuideOption = true;

        this.startGuide(value?.startGuide);
      }

      if (value?.sosAlertActive === 'turnOff') {
        this.stopAlert();
      }
      if (value?.updateProfileDetail) {
        this.updateLoggedInUserDetail();
      }

      if (value?.syncData) {
        this.syncQueuedData();
      }
      if ('isOnEvent' in value) {
        this.ngZone.run(() => {
          this.isOnEvent = value?.isOnEvent;
          this.checkOnlineOffline(this.isAppOnline);
          this.checkWelfareChecks();
        });
      }
      if ('updateEvent' in value) {
        this.showBackBtn = value?.updateEvent !== 'updateJob';
      }
      if (value?.openSelectAccount) {
        this.openSwitchAccountTemplate(value?.logOut);
      }
      if (value?.startAudio) {
        this.audioBtnPressed(value?.fileData);
      }
    });

    this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
      if ('permissionStatus' in value) {
        this.modifyAppStatus(value?.permissionStatus);
      }
      if ('syncComplete' in value && value?.syncComplete) {
        this.isInBackgroundSync = false;
      }
      if ('appStatus' in value) {
        this.internetConnectionAvailable = navigator.onLine;
        this.checkOnlineOffline(value?.appStatus);
      }

      if ('appNewVersionAvailable' in value) {
        this.appNewVersionAvailable =
          sessionStorage.getItem('updateAvailable') === 'true';
      }
      if (value?.subscriptionCheck) {
        this.getSideBar();
      }
    });
    navigator?.serviceWorker?.controller?.postMessage({
      type: 'queuedActionCheck',
    });

    this.serviceWorkerOperations();

    if (this.isSuperUser == true) {
      this.userMenu = superUserMenu;
    }

    if (window.innerWidth >= 1200) {
      this.expandIcon = true;
    }

    this.updateLoggedInUserDetail();
    if (!this.offlineMode) {
      this.userAppChecks();
      if (
        localStorage.getItem('loginSuccess') === 'true' &&
        this.isSubscriptionActive
      ) {
        setTimeout(() => {
          this.afterLoginActions();
        }, 1000);
      }
    }

    this.appService.initializeBootstrapTooltips();

    document.addEventListener('visibilitychange', async () => {
      const excluedPaths = ['/login', '/register', '/subscription'].includes(
        this.currentRoute,
      );

      if (!document.hidden && !excluedPaths) {
        // tab becomes active
        const lastApiCalledTime = Number(
          localStorage.getItem(btoa('lastApiCalledTime')) || '0',
        );
        const now = new Date().getTime();

        // time is compared because this will be triggered when the user tries to uploads images also. We dont need it at the points
        if (lastApiCalledTime && now - lastApiCalledTime > 1000 * 60 * 3) {
          // if the last action was before 3 minuts call an check whether the gps is avialble
          try {
            const gps = await this.deviceInfoService.getGpsForPagesComponent();
          } catch (error: any) {
            if (
              error?.code !== error.PERMISSION_DENIED ||
              error?.message === 'permission-denied'
            )
              this.navigateHome(true);
          }
        }
      }
    });

    this.deviceInfoService.isDeviceChrome().then((value: any) => {
      this.nfcReaderAvailable = 'NDEFReader' in window && value;
    });
  }

  showWelfareButton(response: any) {
    this.welfareTempHoldValue = response?.pending_welfare_check_data;
    this.checkWelfareChecks();
  }
  updateGuardTrackerApp() {
    if (sessionStorage.getItem('updateAvailable') === 'true') {
      this.toasterService.setMessage({
        successMessage: 'Please Wait, Updating Guard Tracker',
        errorMessage: '',
      });
      //making sure that the user is in home page and is doing nothing, to do a reload to clear the cache
      sessionStorage.removeItem('updateAvailable');
      localStorage.setItem('loginSuccess', 'true');
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      this.appNewVersionAvailable = false;
    }
  }
  updateLoggedInUserDetail() {
    let userData = this.appService.getUserData();

    const firstName = userData?.profile?.first_name;
    const lastName = userData?.profile?.last_name;
    const firstLetterFirstName = firstName ? firstName.charAt(0) : '';
    const firstLetterLastName = lastName ? lastName.charAt(0) : '';

    const initialName = `${firstLetterFirstName}${firstLetterLastName}`;
    this.loggedInUser = {
      name: `${userData?.profile?.first_name} ${userData?.profile?.last_name}`,
      initialName: initialName,
    };
  }

  getNotificationCount() {
    if (this.notificationCountTimeoutFn)
      clearTimeout(this.notificationCountTimeoutFn);

    this.notificationCountTimeoutFn = setTimeout(() => {
      this.appNewVersionAvailable = false;
      this.profileService.getNotificationCount().subscribe((response: any) => {
        if (response['status'] == 'success') {
          if (response?.user_token) this.updateUserToken(response?.user_token);
          this.notificationCount = response?.count || 0;
          this.unReadMessageCount = response?.new_messages;
          this.newSupportUpdate = response?.feedback_updates;

          if (this.currentRoute === '/support') {
            this.newSupportUpdate = false;
          }
          if (response?.user_info_updated) {
            this.getSideBar();
          }
          // save server region on localStorage for changing ui params. Used from global.varaible.ts
          localStorage.setItem(
            btoa('INSTANCE_REGION_NAME'),
            response?.INSTANCE_REGION_NAME || 'AUSTRALIA',
          );

          if (!this.isSuperUser) {
            this.checkAndStartGuide(response?.subscriber_user_guide_details);
            this.getSOSAlerts(response?.sos_alerts || 0);
            this.showWelfareButton(response);
            this.updateClientList(response?.client_checksum);
            this.updateQRCheckPointList(response?.qr_checkpoint_checksum);
            if (response?.user_prompt_checksum)
              this.syncUserPrompts(response?.user_prompt_checksum);
            this.updateSiteList(response?.site_checksum);
          }

          this.appService.appVersionCheck({
            last_item: response?.last_item,
          });

          localStorage.setItem(
            'groupUserCount',
            JSON.stringify(response?.user_and_group_count),
          );
          this.conditionalUpdateSideBarMenuItems();

          if (response?.welfare_check_intervals)
            this.updateWelfareAlertTime(response?.welfare_check_intervals);
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });

      this.checkForAllowedRoutes();
    }, 100);
  }
  checkForAllowedRoutes() {
    const appRoutesConfig: any = this.dataCheckService.getAppRouteConfig();

    if (!appRoutesConfig?.allowed_routes?.length && !this.isSuperUser) {
      this.profileService
        .getUserConfig({
          app_route_config: 1,
        })
        .subscribe((resp: any) => {
          if (resp?.app_route_config) {
            localStorage.setItem(
              btoa('appRoutesConfig'),
              resp?.app_route_config,
            );
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: 'Something Went Wrong',
            });
          }
        });
    }
  }

  cancelSubscription() {
    if (this.hasMultipleAccountsLinked) {
      sessionStorage.removeItem(btoa('newAccountLinked'));
      this.openSwitchAccountTemplate(true);
    } else {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate([
        this.isPreviousSubscribed ? '/login' : '/register',
      ]);
    }
  }

  navigateHome(reload = false) {
    if (reload) {
      window.location.reload();
    } else {
      this.router.navigate(['/']);
      document.body.classList.remove('sidebar-open');
    }
  }
  scrollToTop() {
    this.windowScrolled = false;
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 50);
  }

  addfeedback() {
    this.spinnerService.show();
    const feedbackValue: any = this.feedbackForm.get('feedback')?.value;
    let fileData: FormData = new FormData();

    fileData.append('feedback', feedbackValue);
    if (this.feedbackAttachment?.file)
      fileData.append('file', this.feedbackAttachment?.file);
    fileData.append(
      'app_version',
      String(sessionStorage.getItem('appVersion') || ''),
    );
    this.appService
      .formDataApi(`feedback/submit_feedback`, fileData)
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.toasterService.setMessage({
            successMessage: response['message'],
            errorMessage: '',
          });
          this.feedbackForm.reset();
          this.feedbackAttachment = {};
          this.dialogRef.close();
          this.spinnerService.hide();
          this;
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }

  showHideDraggableFeedbackBtn(value: any) {
    if (value === true) {
      let element: any = document.getElementById('globalFeedbackbtn');
      element.style.visibility = 'hidden';
    } else {
      let element: any = document.getElementById('globalFeedbackbtn');
      element.style.visibility = 'visible';
    }
  }

  enableScrollOnBody() {
    document.body.classList.remove('sidebar-open');
  }
  getSubscriberStats() {
    this.existingSupportQueries = false;
    this.spinnerService.show();
    let param: any = {
      time_offset: new Date().getTimezoneOffset(),
      subscriber_stats: 1,
    };

    this.jobService.getDashBoardData(param).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.subscriberStats = response?.data?.subscriber_stats;
        this.existingSupportQueries = response?.data?.support_queries;

        localStorage.setItem(
          'subscriberStats',
          JSON.stringify(response?.data?.subscriber_stats || {}),
        );
        this.spinnerService.hide();
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }

  openSupportQueryCreateTemplate(requestRef: TemplateRef<any>) {
    this.faqItemDict = {};
    this.userCurrentDeviceDetail = {
      time: new Date(),
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    this.getSubscriberStats();
    this.feedbackForm.controls['feedback'].setValue(null);
    this.showHideDraggableFeedbackBtn(true);
    this.deviceInfoService.getDeviceDetail().then((res: any) => {
      if (res) {
        [
          'browser_version',
          'os',
          'browser',
          'os_version',
          'deviceType',
          'device',
        ]?.forEach((key: any) => {
          if (res[key] && res[key]?.toLowerCase() !== 'unknown')
            this.userCurrentDeviceDetail[key] = res[key];
        });
        this.userCurrentDeviceDetail['gps'] = res?.gps;
      }
    });

    this.appService
      .getCurrentVersionInfo()
      .then((data: any) => sessionStorage.setItem('appVersion', data?.version));
    this.dialogRef = this.dialogService.open(
      requestRef,
      {
        data: {},
      },
      this.viewContainerRef,
    );

    this.dialogRef?.afterClosed().subscribe(() => this.feedbackForm.reset());
  }
  updateUserToken(userToken: any) {
    if (!userToken) return;
    let userData = this.appService.getUserData();
    userData.user_token = userToken;
    this.appService.setUserData(userData);
  }

  welfareCheckIn(template: any) {
    if (this.showWelfareCheck?.welfare_check_missed_id) {
      // the user has missed the check in ask reason for missing
      const dialogRef = this.dialogService.open(
        template,
        {},
        this.viewContainerRef,
      );
      dialogRef?.afterClosed()?.subscribe((response: any) => {
        if (response) {
          this.checkIn({
            event_id: this.showWelfareCheck?.welfare_check_missed_id,
            missed_reason: this.welfareCheckMissedReason,
            welfare_check_id: this.showWelfareCheck?.welfare_check_id,
          });
        }
      });
    } else {
      this.checkIn({
        welfare_check_id: this.showWelfareCheck?.welfare_check_id,
      });
    }
  }
  checkIn(body: any) {
    this.showWelfareCheck = null;
    this.welfareTempHoldValue = null;
    this.spinnerService.show();
    this.jobService.welfareCheckIn(body).then((response: any) => {
      if (response?.status == 'success') {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: response?.message,
          errorMessage: '',
        });

        if (body?.welfare_check_id) {
          // to update home page btn
          this.deviceInfoService.deviceInfoSubject.next({
            checkMissedWelfareCheckInBtn: true,
          });
        }
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response?.message,
        });
        this.getNotificationCount();
        this.spinnerService.hide();
      }
    });
  }

  async userAppChecks() {
    if (this.isSuperUser) return;
    //check whther user has set password, first name last name etc

    const isIOSFirstTimeUser =
      (this.isPhoneIOS && !this.largeView && !('gtAppTheme' in localStorage)) ||
      localStorage.getItem(btoa('isIOSFirstTimeUser')) === 'true';

    if (isIOSFirstTimeUser && ['/', '/dashboard'].includes(this.currentRoute)) {
      this.openSplashScreen(true, true);
      return;
    }

    if (
      this.dataCheckService.hasPasswordSet() === false ||
      window.localStorage.getItem('resetPasswordPWA')
    ) {
      if (
        this.dataCheckService.hasPasswordSet() === false &&
        sessionStorage.getItem(btoa('newAccountLinked')) === 'true'
      ) {
        // remove it so that it will not be triggered above the first time user guide
        sessionStorage.removeItem(btoa('newAccountLinked'));
      }
      const dialogRefUser = this.dialogService.open(AppChecksComponent, {
        data: {},
      });
      dialogRefUser.afterClosed().subscribe(async (value: any) => {
        this.spinnerService.hide();
        window.location.reload();
        await this.getSideBar();
      });
    } else if (
      sessionStorage.getItem(btoa('newAccountLinked')) === 'true' &&
      this.isSubscriptionActive
    ) {
      setTimeout(() => {
        sessionStorage.removeItem(btoa('newAccountLinked'));
        this.startGuide('newAccountLinked');
      }, 500);
    }
  }
  toggleSideBarMenu() {
    this.showUserDropdown = false;
    this.navbarToggled = !this.navbarToggled;

    // Add or remove the no-scroll class based on menu state
    if (this.navbarToggled) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
  toggleManageMenu() {
    this.showManageMenu = !this.showManageMenu;
  }
  toggleUserProfileMenu(delay = false) {
    this.arrangeUserMenu();
    if (delay) {
      // addded this so that focus out will be triggered after the click of menu items
      setTimeout(() => {
        this.showUserDropdown = false;
      }, 200);
    } else this.showUserDropdown = !this.showUserDropdown;
  }

  redirectToPage(menuLink: string, userMenu: boolean = false) {
    this.guideChimp?.stop();
    if (menuLink === 'updateApp') {
      this.openChangeLog();
    } else {
      this.router.navigate([menuLink]);
    }
    if (window.innerWidth < 1200 && userMenu === false) {
      this.toggleSideBarMenu();
    }
    this.showManageMenu = false;
    this.showUserDropdown = false;
    this.navbarToggled = false;

    sessionStorage.removeItem('selectedTab');
    sessionStorage.removeItem('fromSite');

    // if (!['/jobs', '/roster', '/reports'].includes(menuLink)) {
    //   const storageKey = btoa('lastUsedRoutes');

    //   const lastUsedRoutes: string[] = JSON.parse(
    //     localStorage.getItem(storageKey) ?? '[]',
    //   );

    //   const updatedRoutes = [
    //     menuLink,
    //     ...lastUsedRoutes.filter((route) => route !== menuLink),
    //   ].slice(0, 3);

    //   localStorage.setItem(storageKey, JSON.stringify(updatedRoutes));
    //   this.getLastUsedRoutes();
    // }
  }
  getLastUsedRoutes() {
    const updatedRoutes: string[] = JSON.parse(
      localStorage.getItem(btoa('lastUsedRoutes')) ?? '[]',
    );

    const completeItems = this.isAdmin
      ? this.sideBarMenuItems?.concat(this.settingItems)
      : this.sideBarMenuItems;

    const menuMap = new Map(
      completeItems.map((item: any) => [item.link, item]),
    );

    this.lastUsedRoutes = updatedRoutes
      .map((route) => menuMap.get(route))
      .filter(Boolean);
  }

  handleWrapperClick(event: Event) {
    // Prevent the wrapper click event from interfering with child elements

    this.navbarToggled = false;
    event.stopPropagation();

    if (this.navbarToggled) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }
  guardTrackerIconClick() {
    this.showManageMenu = false;

    if (['/', '/dashboard'].includes(this.currentRoute)) {
      this.toggleSideBarMenu();
    } else {
      this.navbarToggled = false;
      this.router.navigate(['/']);
      document.body.classList.remove('sidebar-open');
    }
  }

  checkPrevouslySubscribed() {
    return (
      !this.isAdmin ||
      this.dataCheckService.checkIsPreviouslySubscribedAndSubscriptionInActive()
    );
  }
  afterLoginActions() {
    localStorage.removeItem('loginSuccess');
    this.callNearestApis();

    // in case of iphones only pwa gets notification access, so no need in calling this if its from browser and moved the check for pwa to location access check component
    // if (this.isPhoneIOS) return;
    // this.requestSubscription();
  }
  // call the job/cp/cleint apis to build the indexed db cache

  callNearestApis() {
    try {
      this.jobService.getHomeUserPromptList().subscribe((response: any) => {});

      this.jobService
        .getNearestJobs({
          time_offset: new Date().getTimezoneOffset(),
        })
        .subscribe((response: any) => {});
      this.jobService.getAllSiteList().subscribe((response: any) => {});
      this.jobService.getAllClientList().subscribe((response: any) => {});

      const isIOSFirstTimeUser =
        (this.isPhoneIOS &&
          !this.largeView &&
          !('gtAppTheme' in localStorage)) ||
        localStorage.getItem(btoa('isIOSFirstTimeUser')) === 'true';

      if (!isIOSFirstTimeUser) {
        this.jobService
          .getNearestCheckpointList()
          .subscribe((response: any) => {});
        this.jobService.getNearesSiteList().subscribe((response: any) => {});
      }
    } catch (error) {}
  }
  async checkExisitingSubscription() {
    return new Promise((resolve) => {
      this.swPush.subscription.subscribe((res: any) => {
        resolve(res);
      });
    });
  }
  async unsubscribeFromPush() {
    try {
      await this.swPush.unsubscribe();
      // Successfully unsubscribed
    } catch (err) {}
  }
  requestSubscription = async () => {
    if (!this.swPush.isEnabled) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Warning: You have not enabled push notifications',
      });
      return;
    }
    this.swPush
      .requestSubscription({
        serverPublicKey: environment.vapIDPKey,
      })
      .then((_) => {
        this.profileService
          .registerPushNotification({ subscription: JSON.stringify(_) })
          .then((response: any) => {
            if (response['status'] == 'success') {
            } else {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
          });
      })
      .catch(async (_: any) => {
        let existingSub = await this.checkExisitingSubscription();
        if (existingSub) {
          await this.unsubscribeFromPush();
          await this.requestSubscription();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: _,
          });
        }
      });
  };

  async updateQRCheckPointList(qrCpCheckSum: any) {
    const SHORT_PATH = '/api/check_point/list_qr_checkpoints/';
    const serverLastUpdated = qrCpCheckSum?.last_updated_at
      ? new Date(qrCpCheckSum.last_updated_at).getTime()
      : null;
    let checkDb = true;

    if (
      serverLastUpdated &&
      this.syncUpdateCheck?.qr_cp &&
      serverLastUpdated < this.syncUpdateCheck?.qr_cp
    ) {
      checkDb = false;
    }
    if (!checkDb) return;

    try {
      if (qrCpCheckSum?.item_count === 0) {
        await gTDB.cachedData.where({ shortPath: SHORT_PATH }).delete();
        return;
      }
      const cachedRecord = await gTDB.cachedData
        .where('shortPath')
        .equals(SHORT_PATH)
        .first();
      const checkpointData: any = cachedRecord?.data || [];
      const cachedQrCheckpointCount: number = checkpointData?.length;

      const cachedLastUpdated: any = checkpointData?.[0]?.last_updated_at
        ? new Date(checkpointData?.[0]?.last_updated_at)
        : null;
      const needsRefresh =
        cachedQrCheckpointCount !== qrCpCheckSum?.item_count ||
        (cachedLastUpdated &&
          serverLastUpdated &&
          cachedLastUpdated < serverLastUpdated);

      if (needsRefresh) {
        this.jobService
          .getAllQRCheckpointList()
          .subscribe((response: any) => {});
      }

      this.syncUpdateCheck['qr_cp'] = new Date().getTime();
    } catch (error) {
      throw error;
    }
  }

  async syncUserPrompts(userPromptCheckSum: any): Promise<void> {
    const SHORT_PATH = '/api/user_prompt/list_all_prompts/';
    const serverLastUpdated = userPromptCheckSum?.last_updated_at
      ? new Date(userPromptCheckSum.last_updated_at).getTime()
      : null;

    let checkDb = true;

    if (
      serverLastUpdated &&
      this.syncUpdateCheck?.prompt &&
      serverLastUpdated < this.syncUpdateCheck?.prompt
    ) {
      checkDb = false;
    }
    if (!checkDb) return;

    try {
      if (userPromptCheckSum?.item_count === 0) {
        await gTDB.cachedData.where({ shortPath: SHORT_PATH }).delete();
        return;
      }

      const cachedRecord = await gTDB.cachedData
        .where('shortPath')
        .equals(SHORT_PATH)
        .first();

      const userPromptData = cachedRecord?.data ?? [];

      const cachedCount = userPromptData.length;

      const cachedLastUpdated = userPromptData?.[0]?.modified_at
        ? new Date(userPromptData[0].modified_at).getTime()
        : null;

      const needsRefresh =
        cachedCount !== userPromptCheckSum?.item_count ||
        (cachedLastUpdated &&
          serverLastUpdated &&
          cachedLastUpdated < serverLastUpdated);

      if (needsRefresh) {
        this.jobService.getHomeUserPromptList().subscribe((res: any) => {
          if (
            res?.status === 'success' &&
            this.updateUserPromptOnHomePage &&
            (this.currentRoute === '/dashboard' || this.currentRoute === '/')
          ) {
            setTimeout(() => {
              this.deviceInfoService.deviceInfoSubject.next({
                wsn_user_prompt_updates: true,
              });
            }, 500);
          }
          this.updateUserPromptOnHomePage = false;
        });
      }
      this.syncUpdateCheck['prompt'] = new Date().getTime();
    } catch (error) {
      throw error;
    }
  }

  async updateClientList(clientCheckSum: any) {
    const SHORT_PATH = '/api/company/list_all_companies/';
    const serverLastUpdated = clientCheckSum?.last_updated_at
      ? new Date(clientCheckSum.last_updated_at).getTime()
      : null;
    let checkDb = true;

    if (
      serverLastUpdated &&
      this.syncUpdateCheck?.client_list &&
      serverLastUpdated < this.syncUpdateCheck?.client_list
    ) {
      checkDb = false;
    }
    if (!checkDb) return;
    try {
      if (clientCheckSum?.item_count === 0) {
        await gTDB.cachedData.where({ shortPath: SHORT_PATH }).delete();
        return;
      }
      const cachedRecord = await gTDB.cachedData
        .where('shortPath')
        .equals(SHORT_PATH)
        .first();
      const clientListData: any = cachedRecord?.data || [];
      const cachedQrCheckpointCount: number = clientListData?.length;

      const cachedLastUpdated: any = clientListData?.[0]?.last_updated_at
        ? new Date(clientListData?.[0]?.last_updated_at)
        : null;
      const needsRefresh =
        cachedQrCheckpointCount !== clientCheckSum?.item_count ||
        (cachedLastUpdated &&
          serverLastUpdated &&
          cachedLastUpdated < serverLastUpdated);

      if (needsRefresh) {
        this.jobService.getAllClientList().subscribe((response: any) => {});
      }

      this.syncUpdateCheck['client_list'] = new Date().getTime();
    } catch (error) {
      throw error;
    }
  }
  async updateSiteList(siteCheckSum: any) {
    const SHORT_PATH = '/api/site/list_all_sites/';
    const serverLastUpdated = siteCheckSum?.last_updated_at
      ? new Date(siteCheckSum.last_updated_at).getTime()
      : null;
    let checkDb = true;

    if (
      serverLastUpdated &&
      this.syncUpdateCheck?.site_list &&
      serverLastUpdated < this.syncUpdateCheck?.site_list
    ) {
      checkDb = false;
    }
    if (!checkDb) return;
    try {
      if (siteCheckSum?.item_count === 0) {
        await gTDB.cachedData.where({ shortPath: SHORT_PATH }).delete();
        return;
      }
      const cachedRecord = await gTDB.cachedData
        .where('shortPath')
        .equals(SHORT_PATH)
        .first();
      const siteListData: any = cachedRecord?.data || [];

      const cachedQrCheckpointCount: number = siteListData?.length;

      const cachedLastUpdated: any = siteListData?.[0]?.last_updated_at
        ? new Date(siteListData?.[0]?.last_updated_at)
        : null;
      const needsRefresh =
        cachedQrCheckpointCount !== siteCheckSum?.item_count ||
        (cachedLastUpdated &&
          serverLastUpdated &&
          cachedLastUpdated < serverLastUpdated);

      if (needsRefresh) {
        this.jobService.getAllSiteList().subscribe((response: any) => {});
      }

      this.syncUpdateCheck['site_list'] = new Date().getTime();
    } catch (error) {
      throw error;
    }
  }
  async updateWelfareAlertTime(welfareCheckIntervals: any) {
    if (this.swPush.isEnabled) {
      welfareCheckIntervals = welfareCheckIntervals?.filter(
        (item: any) => new Date(item[0]).getTime() > new Date().getTime(),
      );
      await gTDB.userData.delete('welfareCheckIntervals');
      await gTDB.userData.add(welfareCheckIntervals, 'welfareCheckIntervals');
      setTimeout(() => {
        navigator?.serviceWorker?.controller?.postMessage({
          type: 'welfareIntervalCheck',
        });
      }, 500);
    }
  }
  lockScreen() {
    this.orientationLockService.lockOrientation();
  }
  showSOSAlerts() {
    this.router.navigate([
      '/sos-welfare-alerts',
      { alertCounts: String(this.sosAlertCount) },
    ]);
  }
  getSOSAlerts(alertCount: number = 0) {
    if (alertCount == 0) {
      this.isAlertActive = false;

      this.sosAlertCount = 0;
      this.beepIntervalSubscription?.unsubscribe();
      this.pageService.miscSubjectParam.next({ sosAlertActive: 'alertMuted' });
    } else if (
      alertCount != this.sosAlertCount &&
      (this.isAdmin || this.isDispatchUser)
    ) {
      this.pageService.miscSubjectParam.next({ sosAlertActive: 'alertActive' });
      this.isAlertActive = true;
      this.alertUserWithSoundFeedback();
      this.sosAlertCount = alertCount;
      this.router.navigate([
        '/sos-welfare-alerts',
        { alertCounts: String(alertCount) },
      ]);
    }
  }

  stopAlert() {
    this.pageService.miscSubjectParam.next({ sosAlertActive: 'alertMuted' });
    this.isAlertActive = false;
    this.beepIntervalSubscription?.unsubscribe();
  }
  alertUserWithSoundFeedback() {
    this.beepIntervalSubscription = interval(1000)
      .pipe(takeWhile(() => this.isAlertActive))
      .subscribe((x) => {
        this.deviceInfoService.triggerCustomPulsePattern();
        this.toasterService.playChord(0.2, 1000, 100, 'sine');
      });
  }
  modifyAppStatus(value: string) {
    switch (value) {
      case 'locationDisabled':
        this.permissionErrorStatus = {
          icon: 'alert-triangle',
          status: 'danger',
          message: `Warning: Certain functions may not work without access to your location`,
          type: 'locationDisabled',
        };
        const isIOSUser =
          this.isPhoneIOS &&
          !this.largeView &&
          localStorage.getItem(btoa('isIOSFirstTimeUser')) === 'false';
        if (isIOSUser) this.openSplashScreen(false);
        break;
      case 'locationEnabled':
        if (this.permissionErrorStatus?.type === 'locationDisabled') {
          this.permissionErrorStatus = null;
        }

        break;
      case 'cameraDisabled':
        this.permissionErrorStatus = {
          icon: 'alert-triangle',
          status: 'danger',
          message: `Warning: Camera access not given`,
        };
        break;
      case 'notificationDisabled':
        this.permissionErrorStatus = {
          icon: 'alert-triangle',
          status: 'danger',
          message: `Warning: Permission for push notifications not given`,
        };
        break;
    }

    this.cdr.detectChanges();
    const tooltipElement = document.getElementById('customTooltipBtn');

    if (tooltipElement) {
      // Dispose of the existing tooltip instance if it exists
      const existingTooltip = bootstrap.Tooltip.getInstance(tooltipElement);
      if (existingTooltip) {
        existingTooltip.dispose();
      }

      const tooltipInstance = new bootstrap.Tooltip(tooltipElement);
      tooltipInstance.setContent({
        '.tooltip-inner': this.permissionErrorStatus?.message,
      });
      tooltipInstance?.show();
      setTimeout(() => {
        tooltipInstance?.hide();
      }, 1000);
    }
  }

  switchTheme() {
    this.spinnerService.show();
    this.currentTheme = this.appService.getGTAppTheme();
    this.currentTheme = this.currentTheme === 'default' ? 'dark' : 'default';
    this.appService.switchGTAppTheme(this.currentTheme);
    window.location.reload();
    this.spinnerService.hide();
    this.toggleSideBarMenu();
  }
  beforeInstallPromptHandler = (event: any) => {
    event.preventDefault();
    // Stash the event so it can be triggered later
    this.deferredPWAInstallPrompt = event;
    this.isPWAInstalled = false;
  };
  async checkPWAInstallable() {
    // return if there is no service worker
    const swUpdate: any = this.appService.getSWUpdate();

    if (!swUpdate?.isEnabled) return;
    // return if its a pwa
    const isDevicePWA = this.deviceInfoService.isDevicePWA();
    if (isDevicePWA) return;

    window.addEventListener(
      'beforeinstallprompt',
      this.beforeInstallPromptHandler,
    );

    if (this.isPhoneIOS) {
      // for ios `beforeinstallprompt` is not triggered, so if its not a pwa we will show it always
      this.deferredPWAInstallPrompt = true;
      this.isPWAInstalled = false;
    }
    const prompt: any = this.deviceInfoService.deviceInfoSubject.getValue();

    if (prompt?.deferredPWAInstallPrompt) {
      this.deferredPWAInstallPrompt = prompt?.deferredPWAInstallPrompt;
      this.isPWAInstalled = false;
      this.deviceInfoService.deviceInfoSubject.next({});
    }
  }
  installPWAApp() {
    this.spinnerService.show();

    if (this.isPhoneIOS) {
      this.dialogService.open(ScreenshotGuideComponent, {
        data: {},
      });

      this.spinnerService.hide();
    } else if (this.deferredPWAInstallPrompt) {
      this.deferredPWAInstallPrompt.prompt();
      this.spinnerService.hide();
      // Wait for the user to respond to the prompt
      this.deferredPWAInstallPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          // Hide the install button after installation
          this.isPWAInstalled = true;
        }
        // Clear the deferredPrompt variable
        this.deferredPWAInstallPrompt = null;
      });
    } else {
      this.spinnerService.hide();
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'ERROR: Guard Tracker may already be installed',
      });
    }
  }

  continueGuideWithInterval() {
    this.guideChimpInterval = setInterval(() => {
      const guideItemIndex = this.guideItems?.findIndex(
        (item: any) => item.element === this.currentTourElement,
      );

      if (guideItemIndex + 1 === this.guideItems?.length) {
        // last step of the tour; onComplete is not triggering, so using a hack
        if (this.guideChimpInterval) clearInterval(this.guideChimpInterval);
        this.guideChimp?.stop();
      } else {
        this.guideChimp?.next();
      }
    }, 2500);
  }

  attachImageToQuery() {
    const dialogRef = this.dialogService.open(FileUploadComponent, {
      data: { showFrom: 'supportQuery' },
    });

    dialogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        this.feedbackAttachment = {
          file: value?.actualFileUpload,
          fileUrl: value?.fileUrl,
        };
      } else if (value == 'error') {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'Unable to access your camera',
        });
      }
    });
  }
  restartGetStarted() {
    const userGuide = JSON.parse(localStorage.getItem('userGuide') || '{}');
    userGuide['hideGetStarted'] = false;
    localStorage.setItem('userGuide', JSON.stringify(userGuide));
    this.updateGuideLevel();
    this.deviceInfoService.deviceInfoSubject.next({
      restartGetStarted: true,
    });
  }
  getSignInQRImage() {
    return new Promise((resolve: any) => {
      this.spinnerService.show();

      this.profileService
        .getUserConfig({
          remember_login: this.dataCheckService.isTrustedDevice() ? 1 : 0,
          time_offset: new Date().getTimezoneOffset(),
          sign_in_qr: 1,
        })
        .subscribe((resp: any) => {
          this.spinnerService.hide();
          resolve(resp?.data || '');
        });
    });
  }
  getSubscriberStatsFromLS() {
    let subscriberStats;
    const rawStats = localStorage.getItem('subscriberStats');

    try {
      // Check if it exists and isn't the literal string "undefined"
      if (rawStats && rawStats !== 'undefined') {
        subscriberStats = JSON.parse(rawStats);
      } else {
        subscriberStats = {};
      }
    } catch (e) {
      subscriberStats = {};
    }

    return subscriberStats;
  }

  async startGuide(guide: string) {
    let guideItems: any = [];
    switch (guide) {
      case 'basics':
        const multipleAccountsLinked =
          sessionStorage.getItem(btoa('newAccountLinked')) === 'true' ||
          this.hasMultipleAccountsLinked;
        sessionStorage.removeItem(btoa('newAccountLinked'));

        guideItems = [
          {
            element: '#centerScreen',
            title: 'Welcome to Guard Tracker',
            showItem: true,
            position: 'center',
            description: 'Let us show you the basics.',
            // buttons: [
            //   {
            //     title: 'Get Started',
            //     class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
            //     onClick: () => {
            //       this.guideChimp?.next();
            //     },
            //   },
            // ],
          },
          {
            element: '#gtLogo',
            title: 'Home <i class="fa-solid fa-house pe-none"></i>',
            showItem: false,
            position: 'bottom',
            description: 'Tap the logo to return to the home screen.',
          },
          {
            element: '#sidebar-menu',
            title: 'Menu Toggle',
            description: 'Press to show the menu.',
            showItem: true,
            position: 'top',
          },
          {
            element: '.list-group-flush',
            title: 'Navigation',
            description: 'Access key areas of the app.',
            showItem: !this.largeView,
            position: 'top',
          },

          {
            element: '#theme-icon',
            title: 'Toggle Theme',
            description: 'Switch between dark and light themes.',
            showItem: this.isAdmin,
            position: 'top',
          },
          {
            element: '#settings-icon',
            title: 'Settings',
            description: 'Tap the cog to access settings.',
            showItem: this.isAdmin,
            position: 'top',
          },
          {
            element: '#switchAccountIcon',
            title: 'Select this to switch between accounts',
            showItem: multipleAccountsLinked,
            position: 'top',
          },

          {
            element: '#user-menu',
            title: 'User Menu',
            description: 'Update your profile.',
            showItem: !this.isAdmin,
            position: 'top',
          },
          {
            element: '#user-menu',
            title: 'User Menu',
            description: 'Update your profile.',
            showItem: this.isAdmin,
            position: 'top',
          },
          {
            element: '#globalFeedbackbtn',
            title: 'Need Help?',
            showItem: true,
            position: 'bottom',
            description: 'Tap here to contact us.',
          },
          // {
          //   element: '#manageSite',
          //   title: 'Before You Begin',
          //   description: 'Add a site to Guard Tracker',
          //   showItem: this.isAdmin && subscriberStats?.company_count == 1,
          //   position: 'top',
          //   buttons: [
          //     {
          //       title: 'Open Sites',
          //       class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
          //       onClick: () => {
          //         this.guideChimp?.stop();
          //         this.router.navigate(['/client']);
          //         this.showManageMenu = false;
          //         this.toggleSideBarMenu();
          //       },
          //     },
          //   ],
          // },
        ];

        break;

      case 'siteList':
        guideItems = [
          {
            element: '#addSite',
            title: 'Add Site',
            showItem: this.isAdmin,
            position: 'top',
            description: 'Tap the button.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];
        break;

      case 'addNewSite':
        guideItems = [
          {
            element: '#addNewClient',
            title: 'Client',
            showItem: this.isAdmin,
            position: 'top',
            description: 'Enter the client name and tap ADD NEW CLIENT',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];
        break;

      // case 'users':
      //   guideItems = [
      //     {
      //       element: '',
      //       title: 'New Users',
      //       showItem: this.isAdmin,
      //       position: 'top',
      //       description: 'New users will receive a login email.',
      //     },
      //     // {
      //     //   element: '#chatButton',
      //     //   title: 'Start Messaging',
      //     //   description: 'Tap here to send and receive messages.',
      //     //   showItem: this.subscriberStats?.users_exist,
      //     //   position: 'bottom',
      //     // },
      //   ];
      //   break;

      case 'startAlarmResponse':
        guideItems = [
          {
            element: '#addResponseJob',
            title: 'Alarms',
            showItem: this.isAdmin || this.isDispatchUser,
            position: 'top',
            description: 'Add and manage alarm responses.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                  this.startGuide('addAlarmResponse');
                },
              },
            ],
          },
        ];
        break;

      case 'addAlarmResponse':
        this.openSideBarMenu();
        guideItems = [
          {
            element: '#sidebar-menu',
            title: 'Menu Toggle',
            description: 'Open the sidebar menu.',
            showItem: this.isAdmin,
            position: 'top',
          },
          {
            element: '#manageAlarms',
            showItem: this.isAdmin,
            position: 'top',
            description: 'Tap here.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                  this.router.navigate(['/jobs']);
                  this.showManageMenu = false;
                  this.toggleSideBarMenu();
                },
              },
            ],
          },
        ];
        break;

      case 'alarmsPage':
        guideItems = [
          {
            element: '#addResponse',
            title: 'Add Alarm Response',
            showItem: !this.isGuardUser,
            position: 'top',
            description: 'Tap here to add alarm responses.',
          },
          {
            element: '#addCasualPatrol',
            title: 'Casual Patrols',
            showItem: !this.isGuardUser,
            position: 'top',
            description:
              'You can also add casual patrols if the task is not time-critical.',
          },
        ];
        break;

      case 'roster':
        guideItems = [
          {
            element: '#addRoster',
            title: 'Roster Shifts',
            showItem: this.isAdmin && this.largeView,
            position: 'top',
            description:
              'Click on a date to add and assign a job to one of your guards.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
          {
            element: '#addRoster',
            title: 'Roster Shifts',
            showItem: this.isAdmin && !this.largeView,
            position: 'top',
            description:
              'Add and assign shifts.<br><br>We will notify the assignee by email.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];
        break;

      case 'checkpointList':
        guideItems = [
          // {
          //   element: '#centerScreen',
          //   title: 'Checkpoints',
          //   showItem: true,
          //   position: 'center',
          //   description:
          //     'Sign into Guard Tracker from a mobile device to scan and add QR checkpoints.',
          // },
          {
            element: '#addCheckpoint',
            title: 'Add Checkpoint',
            showItem: this.isAdmin && this.largeView,
            position: 'top',
            description:
              'Tap to add location based checkpoints. Location based checkpoints prompt the user to take a photo while at the checkpoint location as proof.',
          },
          {
            element: '#qrCheckpointTab',
            title: 'QR Codes',
            showItem: this.isAdmin && !this.largeView,
            position: 'bottom',
            description: 'Tap here to get QR Codes.',
          },
          {
            element: '#addCheckpoint',
            title: 'Location-based Checkpoints',
            showItem: this.isAdmin && !this.largeView,
            position: 'bottom',
            description:
              'Or tap here to add location-based checkpoints. <br><br>Location-based checkpoints use GPS and photos to ensure proof of service.',
          },
          {
            element: '',
            title:
              'NFC Tags <img src="assets/images/NFC_logo.avif" alt="" class="ms-3 bg-white p-1 rounded" width="22"/>',
            showItem: this.isAdmin && !this.largeView && this.iosSafariBrowser,
            position: 'bottom',
            description:
              'NFC tags can be used as checkpoints, however they can only be scanned on <span class="fw-semibold">Android devices running Chrome</span>.',
          },
        ];
        break;
      case 'reports':
        guideItems = [
          {
            element: '#reportTabs',
            title: 'Reports',
            showItem: this.isAdmin,
            position: 'top',
            description: `These ${this.largeView ? 'tabs' : 'options'} allow you to generate reports on demand for completed patrols, alarm responses, static guard shifts, and any service jobs.`,
          },
          // {
          //   element: '#configuredReportsTab',
          //   title: 'Configured Reports',
          //   showItem: this.isAdmin,
          //   position: 'top',
          //   description: 'See all the reports you have setup here.',
          //   buttons: [
          //     {
          //       title: 'OK',
          //       class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
          //       onClick: () => {
          //         this.guideChimp?.stop();
          //       },
          //     },
          //   ],
          // },
        ];
        break;

      case 'viewClient':
        guideItems = [
          {
            element: '#editClientName',
            title: 'Update Details',
            showItem: this.isAdmin,
            position: 'top',
            description:
              'Clicking on blue text will allow you to edit details or view more.',
          },

          {
            element: '#clientJobReports',
            title: 'Completed Job Reports',
            showItem: this.isAdmin && this.largeView,
            position: 'top',
            description: 'Add contacts you want to send reports to here.',
          },
          {
            element: '#clientJobReports',
            title: 'Completed Job Reports',
            showItem: this.isAdmin && !this.largeView,
            position: 'top',
            description: 'Add contacts you want to send reports to here.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },

          {
            element: '#clientHistory',
            title: 'Updates',
            showItem: this.isAdmin && this.largeView,
            position: 'top',
            description: 'Updates are recorded here.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];
        break;

      case 'companyProfile':
        guideItems = [
          {
            element: '#companyLogo',
            title: 'Company Logo',
            showItem: true,
            position: 'top',
            description:
              'If uploaded, your company logo will be shown in emails and reports.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.next();
                },
              },
            ],
          },

          {
            element: '#companyLicence',
            title: 'Master Licence',
            showItem: true,
            position: 'top',
            description: 'Add your company level licences here.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];
        break;

      case 'jobDetail':
        guideItems = [
          {
            element: '#jobSiteInfo',
            title: 'Site Information',
            showItem: !this.isAdmin && !this.largeView,
            position: 'top',
            description:
              'Tap the site name to see more information about the site.',
          },
          // {
          //   element: '#jobSiteInfoLink',
          //   title: 'More Site Information',
          //   showItem: !this.isAdmin && !this.largeView,
          //   position: 'top',
          //   description:
          //     'Press this link icon to see more detailed information about the site.',
          // },
          {
            element: '#jobAddressLink',
            title: 'Show On Map',
            showItem: !this.isAdmin && !this.largeView,
            position: 'top',
            description: 'Tap the address to show the address on a map.',
          },

          // TODO: Need more conditions here in case the job type is `static guard` and requires clock-in first
          // {
          //   element: '#jobChangeStatus',
          //   title: 'Change Status',
          //   showItem: !this.isAdmin && !this.largeView,
          //   position: 'top',
          //   description: 'Update the status of this job.',
          // },
          // {
          //   element: '#jobUpdateButtons',
          //   title: 'Job Updates',
          //   showItem: !this.isAdmin && !this.largeView,
          //   position: 'top',
          //   description: 'Add photos and comments related to the job.',
          //   buttons: [
          //     {
          //       title: 'OK',
          //       class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
          //       onClick: () => {
          //         this.guideChimp?.stop();
          //       },
          //     },
          //   ],
          // },
        ];
        break;
      case 'patrolJob':
        this.updateBottomSectionStyling();
        guideItems = [
          {
            element: '#patrolCheckpoints',
            title: 'Checkpoints',
            showItem: !this.largeView,
            position: 'top',
            description:
              'These checkpoints need to be scanned inside the shift window.',
          },
          {
            element: '#patrolSiteUpdateButton',
            title: 'Patrol Updates',
            showItem: !this.isAdmin && !this.largeView,
            position: 'top',
            description:
              'Add comments and photos related to the patrol using these buttons below. Comments and photos must be linked to a site.',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];

        break;
      case 'howToAddSite':
        this.openSideBarMenu();
        guideItems = [
          {
            element: '#sidebar-menu',
            title: 'Menu Toggle',
            description: 'Press here to toggle the menu.',
            showItem: true,
            position: 'top',
          },
          {
            element: '#manageSite',
            title: '',
            description: 'Tap SITES from navigation menu',
            showItem: this.isAdmin,
            position: 'top',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                  this.router.navigate(['/client']);
                  this.showManageMenu = false;
                  this.toggleSideBarMenu();
                },
              },
            ],
          },
        ];

        break;

      // case 'howToScanCheckpoint':
      //   guideItems = [
      //     {
      //       element: '#scanQRButton',
      //       title: 'QR Checkpoints',
      //       description:
      //         'These are used if you need to prove someone was at a location or to track assets.<br><br>Tap this button and scan a QR code or barcode.',
      //       showItem: !this.largeView && (this.isAdmin || this.isDispatchUser),
      //       position: 'top',
      //     },
      //     {
      //       element: '#scanQRButton',
      //       title: 'QR Codes',
      //       description: 'Tap this button to scan QR codes.',
      //       showItem:
      //         !this.largeView && (!this.isAdmin || !this.isDispatchUser),
      //       position: 'top',
      //     },
      //     {
      //       element: '#scanNFCButton',
      //       title: 'NFC Tags',
      //       description: 'Tap this button to scan NFC tags.',
      //       showItem: !this.largeView && this.nfcReaderAvailable,
      //       // TODO: need to add more conditions here to showItem only if device is android with chrome
      //       position: 'top',
      //     },
      //     {
      //       element: '#scanCheckpoint',
      //       title: 'Checkpoints',
      //       description: 'Tap this button to scan location based checkpoints.',
      //       showItem:
      //         !this.largeView && this.subscriberStats?.checkpoint_count != 0,
      //       position: 'top',
      //     },
      //     {
      //       element: '#patrolUpdateHomeBtns',
      //       title: 'Comments & Photos',
      //       description:
      //         'These buttons allow you to upload comments and photos related to a site.',
      //       showItem:
      //         !this.largeView && this.subscriberStats?.checkpoint_count != 0,
      //       position: 'top',
      //     },
      //     {
      //       element: '#manageCheckpoint',
      //       title: '',
      //       description:
      //         'You can create checkpoints based on GPS coordinates by tapping on CHECKPOINTS.',
      //       showItem: this.isAdmin && this.largeView,
      //       position: 'top',
      //       buttons: [
      //         {
      //           title: 'OK',
      //           class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
      //           onClick: () => {
      //             this.guideChimp?.stop();
      //             this.router.navigate(['/checkpoints']);
      //             this.showManageMenu = false;
      //             this.toggleSideBarMenu();
      //           },
      //         },
      //       ],
      //     },
      //     {
      //       element: '#scanQRButton',
      //       title: 'Get QR Codes',
      //       description: 'Create  QR codes if you need them.',
      //       showItem: this.isAdmin,
      //       position: 'top',
      //       buttons: [
      //         {
      //           title: 'Skip For Now',
      //           class: 'btn btn-outline-primary mt-3 w-50 w-lg-75 m-2',
      //           onClick: () => {
      //             this.guideChimp?.stop();
      //           },
      //         },
      //         {
      //           title: 'Show Me',
      //           class: 'btn gc-btn mt-3 w-50 w-lg-75 m-2',
      //           onClick: () => {
      //             this.guideChimp?.stop();
      //             this.startGuide('createQRCodes');
      //           },
      //         },
      //       ],
      //     },
      //   ];
      //   break;

      // case 'createQRCodes':
      //   this.openSideBarMenu();
      //   guideItems = [
      //     {
      //       element: '#sidebar-menu',
      //       title: 'Menu Toggle',
      //       description: 'Open the sidebar menu.',
      //       showItem: this.isAdmin,
      //       position: 'top',
      //     },
      //     {
      //       element: '#manageCheckpoint',
      //       title: '',
      //       description: 'Tap checkpoints.',
      //       showItem: this.isAdmin,
      //       position: 'top',
      //       buttons: [
      //         {
      //           title: 'OK',
      //           class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
      //           onClick: () => {
      //             this.guideChimp?.stop();
      //             this.router.navigate(['/checkpoints']);
      //             this.showManageMenu = false;
      //             this.toggleSideBarMenu();
      //           },
      //         },
      //       ],
      //     },
      //   ];
      //   break;

      case 'signInOnMobile':
        let qrImageSrc = 'assets/images/guardtracker-signin.avif';
        const signInQRImage = await this.getSignInQRImage();

        guideItems = [
          {
            element: '#signInOnMobile',
            title: 'Continue on your Mobile',
            showItem: true,
            position: 'center',
            description: `Scan the QR code with your phone and sign in to access features only available on mobile devices.<br><br><div class="text-center"><img src="${
              signInQRImage || qrImageSrc
            }" alt="" class="bg-white p-1" width="200" /></div>`,
            buttons: [
              {
                title: 'Ok',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];

        break;
      case 'hideGetStarted':
        guideItems = [
          {
            element: '#globalFeedbackbtn',
            title: 'Getting Started',
            description: 'Tap here to access the Getting Started guide again.',
            showItem: true,
            position: 'bottom',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];
        break;

      case 'howToAddUser':
        guideItems = [
          {
            element: '#howToAddUser',
            title: 'Adding Users',
            showItem: true,
            position: 'center',
            description: 'Guard Tracker is designed for multiple users.',
          },
          {
            element: '#sidebar-menu',
            title: 'Menu Toggle',
            description: 'Tap here to toggle the menu.',
            showItem: true,
            position: 'top',
          },
          {
            element: '#settings-icon',
            title: 'Settings',
            description: 'Tap the cog to access settings.',
            showItem: true,
            position: 'top',
          },
          {
            element: '#manageGuards',
            title: '',
            description: 'Then tap USERS.',
            showItem: true,
            position: 'top',
            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                  this.router.navigate(['/users']);
                  this.showManageMenu = false;
                  this.toggleSideBarMenu();
                },
              },
            ],
          },
        ];
        break;
      case 'publishShifts':
        guideItems = [
          {
            element: '#publishShiftBtn',
            title: 'Publish Shifts',
            showItem: true,
            position: 'bottom',
            description:
              'Click the button to send an email notification to all users assigned to jobs.',

            buttons: [
              {
                title: 'OK',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                },
              },
            ],
          },
        ];
        break;

        // case 'inAppMessaging':
        //   guideItems = [
        //     {
        //       element: '#chatButton',
        //       title: 'In-App Messaging',
        //       description:
        //         'With another user added, you can now exchange messages with each other.',
        //       showItem: this.subscriberStats?.users_exist,
        //       position: 'bottom',
        //     },
        //   ];
        //   break;

        this.navbarToggled = false;
        this.showManageMenu = false;
        guideItems = [
          {
            showItem: true,
            element: '#scanCheckpointTemplateId',
            title: 'Buttons Have Moved',
            description:
              'Tap here to scan checkpoints, NFC tags, and QR codes.',
            position: 'top',
          },
        ];
        break;
      case 'newAccountLinked':
        guideItems = [
          {
            element: '#centerScreen',
            title: 'Switch Accounts',
            showItem: true,
            position: 'center',
            description: 'You can switch between your accounts',
            showNextButton: false,
            showPrevButton: false,
            buttons: [
              {
                title: 'Show me',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.next();
                },
              },
            ],
          },
          {
            element: '#sidebar-menu',
            title: 'Menu Toggle',
            description: 'Press here to toggle the menu.',
            showItem: true,
            position: 'top',
          },

          {
            element: '#switchAccountIcon',
            title: 'Select this to switch between accounts',
            showItem: true,
            position: 'top',
            buttons: [
              {
                title: 'Switch Account',
                class: 'btn gc-btn mt-3 w-50 w-lg-75 ms-auto',
                onClick: () => {
                  this.guideChimp?.stop();
                  this.openSwitchAccountTemplate();
                  this.toggleSideBarMenu();
                },
              },
            ],
          },
        ];
    }
    guideItems = guideItems?.filter((item: any) => item?.showItem);
    this.guideItems = [...guideItems];
    if (!guideItems?.length) return;

    //https://github.com/Labs64/GuideChimp/wiki/Configure#methods

    this.guideChimp = GuideChimp(guideItems, {
      exitOverlay: false,
      showPagination: false,
      interaction: false,
      showProgressbar: false,
    });
    setTimeout(() => {
      this.guideChimp?.start();
      if (guideItems?.length < 2) {
        setTimeout(() => {
          const navContainer = document.querySelector('.gc-navigation');
          if (navContainer) navContainer.classList.add('d-none');
        }, 100);
      }
    }, 500);

    this.guideChimp?.on('onBeforeChange', (to: any, from: any) => {
      if (from && from.condition && !from.condition()) {
        return false; // Prevent transition if condition is not met
      }

      return true;
    });
    this.guideChimp?.on('onStop', () => {
      if (this.guideChimpInterval) clearInterval(this.guideChimpInterval);

      const userGuide = JSON.parse(localStorage.getItem('userGuide') || '{}');
      userGuide[guide] = true;

      localStorage.setItem('userGuide', JSON.stringify(userGuide));
      if (['patrolJob', 'jobDetail'].includes(guide)) {
        this.updateBottomSectionStyling('add');
      }
      this.updateGuideLevel();
    });
    this.guideChimp?.on('onPrevious', (to: any, from: any) => {
      if (
        from.element === '#sidebar-menu' &&
        ['#gtLogo', '#howToAddSite', '#howToAddUser', '#centerScreen'].includes(
          to.element,
        )
      ) {
        this.toggleSideBarMenu();
      }
      if (
        from.element === '#settings-icon' &&
        ['#sidebar-menu'].includes(to.element)
      ) {
        // add user check
        this.showManageMenu = false;
      }

      if (from.element === '#manageGuards' && to.element == '#centerScreen')
        this.showManageMenu = false;
    });
    if (guideItems?.length > 1)
      this.guideChimp.on('onAfterChange', (step: any, tour: any) => {
        const currentStepNum = step.step + 1;

        const navContainer = document.querySelector('.gc-navigation');
        if (navContainer) navContainer.classList.add('d-flex');
        const nextBtn = document.querySelector('.gc-navigation-next');

        if (navContainer && nextBtn) {
          let counter: any = navContainer.querySelector('.gc-step-counter');
          if (!counter) {
            counter = document.createElement('span');
            counter.className = 'gc-step-counter';
            navContainer.insertBefore(counter, nextBtn);
          }
          counter.innerText = `${currentStepNum} / ${guideItems?.length}`;
        }
      });

    this.guideChimp?.on('onNext', (to: any, from: any) => {
      this.currentTourElement = to.element;

      if (
        ['#sidebar-menu'].includes(from.element) &&
        ['#settings-icon'].includes(to.element)
      ) {
        // add user check
        this.showManageMenu = true;
      }
      if (
        ['#gtLogo', '#howToAddSite', '#howToAddUser', '#centerScreen'].includes(
          from.element,
        ) &&
        to.element == '#sidebar-menu'
      )
        this.openSideBarMenu();
    });
  }
  openSideBarMenu() {
    this.navbarToggled = false;
    this.showManageMenu = false;
    this.toggleSideBarMenu();
  }
  getBasePath(url: string): string {
    if (url == '/') return url;
    const urlTree = this.router.parseUrl(url);
    const urlSegments = urlTree.root.children['primary'].segments;
    url = urlSegments?.length ? '/' + urlSegments[0]?.path : '/';
    return url;
  }
  openSplashScreen(firstTime = true, callAppChecks = false) {
    if (this.splashScreenOpened) return;
    this.splashScreenOpened = true;
    const dialogRef = this.dialogService.open(SplashScreenComponent, {
      data: { firstTime: firstTime },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      this.getNotificationCount();
      this.splashScreenOpened = false;
      localStorage.setItem(btoa('isIOSFirstTimeUser'), 'false');
      if (firstTime) this.callNearestApis();
      if (callAppChecks) this.userAppChecks();
    });
  }

  checkAndStartGuide(userGuideStored: any) {
    if (!userGuideStored) {
      localStorage.removeItem('userGuide');
      return;
    }
    // case where the user needs to add password and details
    if (
      this.dataCheckService.hasPasswordSet() === false ||
      window.localStorage.getItem('resetPasswordPWA')
    )
      return;
    const baseUrl = this.getBasePath(this.router.url);
    const isIOSFirstTimeUser =
      (this.isPhoneIOS && !this.largeView && !('gtAppTheme' in localStorage)) ||
      localStorage.getItem(btoa('isIOSFirstTimeUser')) === 'true';

    if (isIOSFirstTimeUser && ['/', '/dashboard'].includes(baseUrl)) {
      // https://app.shortcut.com/sendem/story/10710/add-allow-location-services-access-for-mobile-splash-page
      // we will open a dialog box here to show the splash screen, then will mark the user as not the first time user
      this.openSplashScreen();
      return;
    }
    let userGuideInBrowser = JSON.parse(
      localStorage.getItem('userGuide') || '{}',
    );
    userGuideStored = { ...userGuideInBrowser, ...(userGuideStored || {}) };

    localStorage.setItem('userGuide', JSON.stringify(userGuideStored));

    let key: any = '';

    switch (baseUrl) {
      case '/':
        // home page
        key = 'basics';
        break;
      case '/dashboard':
        // home page
        key = 'basics';
        break;
      case '/client':
        key = 'siteList';
        break;
      case '/roster':
        key = 'roster';
        break;
      case '/jobs':
        key = 'alarmsPage';
        break;
      case '/checkpoints':
        key = 'checkpointList';
        break;
      case '/reports':
        key = 'reports';
        break;
      case '/view-site':
        key = 'viewSite';
        break;
      case '/view-client':
        key = 'viewClient';
        break;
      case '/view-route':
        key = 'patrolJob';
        break;
      case '/job-detail':
        key = 'jobDetail';
        break;
      case '/users':
        key = 'users';
        break;
      case '/company-profile':
        key = 'companyProfile';
        break;
    }
    if (!key) return;

    if (!userGuideStored?.[key]) {
      if (!this.onBoarding?.[key]) {
        this.onBoarding[key] = true;
        this.startGuide(key);
      }
    }
  }
  clearAllDataAndReload() {
    const userData = this.appService.getUserData();

    localStorage.clear();
    sessionStorage.clear();
    this.appService.setUserData(userData);
    localStorage.setItem('loginSuccess', 'true');
    this.router.navigate(['/']).then(() => {
      window.location.reload();
    });
  }
  openScreenShotComponent() {
    this.dialogService.open(ScreenshotGuideComponent, {
      data: { guide: 'safariPermissionPrompts' },
    });
  }
  restartTutorial() {
    this.onBoarding = {};
    this.spinnerService.show();

    const userGuide = JSON.parse(localStorage.getItem('userGuide') || '{}');

    const hideGetStarted = userGuide?.hideGetStarted || true;

    localStorage.setItem(
      'userGuide',
      JSON.stringify({
        hideGetStarted: hideGetStarted,
      }),
    );

    this.updateGuideLevel();
    setTimeout(() => {
      this.getNotificationCount();
      this.spinnerService.hide();
    }, 500);
    this.router.navigate(['/']);
  }
  updateBottomSectionStyling(action = 'remove') {
    if (action == 'remove') {
      const bottomSection = document.querySelector('.bottom-section');

      if (bottomSection) {
        this.guideStyleOperationsNeeded.jobDetails = {
          bottomSection: bottomSection,
        };

        bottomSection.classList.remove('bottom-section');
      }
    } else {
      if (this.guideStyleOperationsNeeded?.jobDetails?.bottomSection)
        this.guideStyleOperationsNeeded.jobDetails.bottomSection.classList.add(
          'bottom-section',
        );
    }
  }
  updateGuideLevel() {
    // method to update the completed steps of the guide in the backend also,
    // so that even if the localStorage is cleared or the user logs in another device it wont be repeated.
    const userGuide = JSON.parse(localStorage.getItem('userGuide') || '{}');
    this.spinnerService.show();
    this.profileService
      .updateUser(
        {
          data: {
            user_guide_info: userGuide,
          },
        },
        { save_preference: 1 },
        false,
      )
      .then((response: any) => {
        if (response?.status === 'success') {
          localStorage.setItem('userGuide', JSON.stringify(userGuide));

          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
        }
      });
  }
  exitUser() {
    if (!this.isSuperUserAccess) return;
    this.spinnerService.show();
    const superUserAcessData: any = localStorage.getItem(
      btoa('superUserAcessData'),
    );
    const masqueradedFrom =
      sessionStorage.getItem(btoa('masqueradedFrom')) || '/gtadmin/subscribers';

    let routePath: any = ['/gtadmin/subscribers'];
    let routeDict = {};

    try {
      const url = new URL(masqueradedFrom);
      const [basePath, matrixString] = url.pathname.split(';');

      // Parse matrix string into an object: { sKey: "8d4c81f2..." }
      const matrixParams = matrixString
        ? Object.fromEntries(matrixString.split(';').map((p) => p.split('=')))
        : {};

      routePath = [basePath, matrixParams];

      const queryParams = Object.fromEntries(url.searchParams.entries());

      const fragment = url.hash ? url.hash.substring(1) : null;
      routeDict = { queryParams, fragment: fragment || undefined };
    } catch (error) {}

    sessionStorage.clear();
    localStorage.clear();
    localStorage.setItem('userData', superUserAcessData);

    setTimeout(() => {
      this.router.navigate(routePath, routeDict).then(() => {
        window.location.reload();
        this.spinnerService.hide();
      });
    }, 500);
  }
  clearAndFocusTextBox(elementId: string) {
    this.feedbackForm.controls['feedback'].setValue('');
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }

  async audioBtnPressed(fileData: any) {
    this.audioFileData = fileData;

    clearTimeout(this.recordingBtnTimer);

    this.audioTemplateRef = this.dialogService.open(
      this.audioRecordingTemplate,
      {},
      this.viewContainerRef,
    );
    this.recordingStarted = false;
    const maxRetries = 5;
    let retries = 0;

    while (
      (this.isAudioRecording || this.audioChunks?.length) &&
      retries < maxRetries
    ) {
      await this.pageService.delay(1000); // wait 1 second
      retries++;
    }
    if (this.isAudioRecording || this.audioChunks?.length) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Something went wrong',
      });
      this.audioTemplateRef?.close();
      return;
    }
    setTimeout(() => {
      this.startRecording();
    }, 100);
  }
  async startRecording() {
    try {
      this.isAudioRecording = true;

      this.recordingTime = 0;
      const getSupportedMimeType = () => {
        const types = ['audio/mp4', 'audio/webm', 'audio/ogg', 'audio/wav'];
        return (
          types.find((type) => MediaRecorder.isTypeSupported(type)) ||
          'audio/webm'
        );
      };
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      this.mediaRecorder = new MediaRecorder(stream, {
        mimeType: getSupportedMimeType(),
      });

      this.mediaRecorder.onerror = (e) => {
        throw e;
      };
      if (this.speechRecognition) {
        this.speechRecognition?.abort();
      }

      const SpeechRecognition =
        (window as any).SpeechRecognition ||
        (window as any).webkitSpeechRecognition;

      if (SpeechRecognition) {
        this.speechRecognition = new SpeechRecognition();
        this.speechRecognition.continuous = false;
        this.speechRecognition.lang = 'en-AU';
        this.speechRecognition.interimResults = true;
        this.speechRecognition.maxAlternatives = 1;
        this.speechRecognitionText = '';
        let finalTranscript = '';

        this.speechRecognition.onresult = (event: any) => {
          let interim = '';

          for (let i = event.resultIndex; i < event.results.length; i++) {
            const res = event.results[i];

            const text = res[0].transcript;

            if (res.isFinal) {
              finalTranscript += text + ' ';
            } else {
              interim += text;
            }
          }

          this.speechRecognitionText = finalTranscript + interim;
          this.cdr.detectChanges();
        };

        this.speechRecognition.onend = (event: any) => {
          setTimeout(() => {
            try {
              if (this.isAudioRecording) this.speechRecognition.start();
            } catch (e) {}
          }, 300);
        };
      }

      this.audioChunks = [];
      this.mediaRecorder.ondataavailable = (e) => {
        this.audioChunks.push(e.data);
      };

      this.mediaRecorder.onstart = () => {
        this.recordingStarted = true;

        this.cdr.detectChanges();
        this.startTimer();
        setTimeout(() => {
          this.initWaveform(stream);
        }, 300);
      };

      this.mediaRecorder.start(100);
      this.speechRecognition?.start();
    } catch (error: any) {
      this.audioTemplateRef?.close();
      if (
        error.name === 'NotAllowedError' ||
        error.name === 'PermissionDeniedError'
      ) {
        this.dialogService.open(ConfirmDialogComponent, {
          data: {
            title: 'Permission Denied',
            message:
              'Please enable microphone access in your browser settings to record audio.',
            btn2Detail: { text: 'OK' },
          },
        });
      } else if (
        error.name === 'NotFoundError' ||
        error.name === 'DevicesNotFoundError'
      ) {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'No microphone found on this device.',
        });
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'An unexpected error occurred',
        });
      }
      this.isAudioRecording = false;

      this.recordingTime = 0;
      this.audioChunks = [];
      throw error;
    }
  }
  startTimer() {
    this.recordingTimerInterval = setInterval(() => {
      this.recordingTime++;
      this.cdr.detectChanges();
    }, 1000);
  }

  stopRecordingAndSendMessage() {
    clearInterval(this.recordingTimerInterval);
    this.mediaRecorder?.stop();
    this.speechRecognition?.stop();

    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close();
    }
    // this.spinnerService.show('Processing Audio');
    cancelAnimationFrame(this.animationId);

    if (this.mediaRecorder?.stream) {
      this.mediaRecorder.stream.getTracks().forEach((track) => track.stop());
    }

    this.recordingTime = 0;
    if (this.speechRecognition) {
      this.speechRecognition?.abort();
    }
    // this.spinnerService.show('Processing Audio');
    this.mediaRecorder.onstop = async () => {
      const mimeType = this.mediaRecorder.mimeType;
      let [fileData, messageBody] = this.audioFileData;
      messageBody['file_extension'] = '.mp3';

      let backupfileDict: any = {
        ...messageBody,
        additional_info: { audio_transcription_complete: false },
        message: this.speechRecognitionText,
      };

      fileData.forEach((value: any, key: any) => {
        backupfileDict[key] = value;
      });

      fileData.append('messageBody', JSON.stringify(messageBody));

      const audioBlob = new Blob(this.audioChunks, { type: mimeType });
      backupfileDict['file'] = URL.createObjectURL(audioBlob);

      this.pageService.miscSubjectParam.next({
        response: backupfileDict,
        preProcess: true,
      });

      const extension = mimeType.includes('mp4') ? 'm4a' : 'webm';

      const audioFile = new File(
        [audioBlob],
        `voice_${Date.now()}.${extension}`,
        {
          type: mimeType,
          lastModified: Date.now(),
        },
      );
      fileData.append('file', audioFile);

      this.sendAudioMessage(fileData);
    };
  }
  stopRecordingAndRemoveAudio() {
    clearInterval(this.recordingTimerInterval);
    this.mediaRecorder?.stop();
    this.speechRecognition?.stop();

    if (this.audioContext && this.audioContext.state !== 'closed') {
      this.audioContext.close();
    }

    cancelAnimationFrame(this.animationId);

    if (this.mediaRecorder?.stream) {
      this.mediaRecorder.stream.getTracks().forEach((track) => track.stop());
    }

    this.recordingTime = 0;
    this.audioChunks = [];
    this.isAudioRecording = false;
  }
  initWaveform(stream: MediaStream) {
    this.audioContext = new AudioContext();
    this.audioRecordingAnalyser = this.audioContext.createAnalyser();

    this.audioRecordingAnalyser.fftSize = 256;
    const bufferLength = this.audioRecordingAnalyser.frequencyBinCount;
    this.audioRecordingDataArray = new Uint8Array(bufferLength);

    this.audioRecordingSource =
      this.audioContext.createMediaStreamSource(stream);
    this.audioRecordingSource.connect(this.audioRecordingAnalyser);

    this.canvas = document.getElementById('waveCanvas') as HTMLCanvasElement;
    this.canvasCtx = this.canvas.getContext('2d')!;
    this.setCanvasSize();
    this.drawWaveform();
  }
  setCanvasSize() {
    const rect = this.canvas.getBoundingClientRect();

    this.canvas.width = rect.width;
    this.canvas.height = rect.height;
  }
  drawWaveform() {
    if (!this.isAudioRecording) return;

    this.animationId = requestAnimationFrame(() => this.drawWaveform());

    this.audioRecordingAnalyser.getByteFrequencyData(
      this.audioRecordingDataArray,
    );

    const ctx = this.canvasCtx;
    const width = this.canvas.width;
    const height = this.canvas.height;

    ctx.clearRect(0, 0, width, height);

    const barCount = this.largeView ? 100 : 65;
    const gap = 2;
    const barWidth = (width - gap * (barCount - 1)) / barCount;

    let x = 0;
    ctx.fillStyle = '#25D366';
    for (let i = 0; i < barCount; i++) {
      const value = this.audioRecordingDataArray[i];
      const barHeight = (value / 255) * height;
      ctx.fillRect(x, (height - barHeight) / 2, barWidth, barHeight);
      x += barWidth + gap;
    }
  }
  sendAudioMessage(fileData: any) {
    fileData.append('message', this.speechRecognitionText);
    this.audioChunks = [];
    this.isAudioRecording = false;
    this.appService
      .formDataApi('gt_message/send_message', fileData)
      .then((response: any) => {
        this.pageService.miscSubjectParam.next({
          response: response,
          afterResponse: true,
        });
      });
  }

  async isClockInOutSelfieRequired() {
    return new Promise((resolve) => {
      if (this.largeView) {
        resolve(false);
      } else {
        const subscriberSettings =
          this.dataCheckService.getSubscriberSettings();

        if ('clock_in_out_selfie' in subscriberSettings) {
          resolve(subscriberSettings?.clock_in_out_selfie);
        } else {
          this.profileService
            .getUserConfig({
              user_token: 1,
            })
            .subscribe((resp: any) => {
              if (resp?.user_token) {
                this.updateUserToken(resp?.user_token);

                const subscriberSettings =
                  this.dataCheckService.getSubscriberSettings();
                resolve(subscriberSettings?.clock_in_out_selfie);
              } else {
                this.toasterService.setMessage({
                  successMessage: '',
                  errorMessage: 'Something Went Wrong',
                });
              }
            });
        }
      }
    });
  }

  async openDialog(component: any, data: any): Promise<any> {
    const dialogRef = this.dialogService.open(component, { data });
    return await firstValueFrom(dialogRef.afterClosed());
  }

  onAccountChange(res: any) {
    this.appService.onAccountChange(res);

    this.router.navigate(['/']).then(() => {
      window.location.reload();
    });
    this.spinnerService.hide();
  }
  changeAccount(subscriber: any) {
    this.spinnerService.show();
    if (subscriber?.login_access_data) {
      this.onAccountChange(subscriber?.login_access_data);
    } else {
      let userData = this.appService.getUserData();
      this.profileService
        .associatedCompanies({
          subscriber_id: subscriber.id,
          remember_login: userData?.token_expiry ? 1 : 0,
        })
        .subscribe((res: any) => {
          if (res['status'] === 'success') {
            this.onAccountChange(res);
          } else {
            this.spinnerService.hide();
          }
        });
    }
  }
  checkForInCompleteShifts() {
    return new Promise(async (resolve: any) => {
      const currentTime = new Date().getTime();

      let endTimes = new Set<number>();
      const pendingShifts: any = [];
      const result: any = await gTDB.cachedData
        .where({ shortPath: '/api/job/list_nearest/' })
        .toArray();

      const shifts = result?.[0]?.data;

      shifts?.forEach((shift: any) => {
        let endDateTime = new Date();
        if (shift?.schedule_details?.repeat_type == 'once') {
          endDateTime = new Date(
            shift?.schedule_details?.end_day +
              ' ' +
              shift?.schedule_details?.end_time,
          );
        } else {
          endDateTime = new Date(
            shift?.schedule_details?.event_date +
              ' ' +
              shift?.schedule_details?.end_time,
          );
          if (
            shift?.schedule_details?.end_time <
            shift?.schedule_details?.start_time
          ) {
            // overnight schedule
            endDateTime.setDate(endDateTime.getDate() + 1);
          }
        }

        if (endDateTime.getTime() > currentTime)
          endTimes.add(endDateTime.getTime());

        const pendingCheckpointScans =
          shift?.checkpoints_remaining > 0 && shift?.job_type_key == 4;
        const pendingTasks =
          shift?.job_type_key === -1 &&
          shift?.additional_info?.task_stats?.completed_tasks <
            shift?.additional_info?.task_stats?.total_tasks;

        let pendingJobs = false;
        if (![4, -1].includes(shift?.job_type_key)) {
          let activeStatuses = ['0', '4', '8'];
          if (shift?.job_type_key != 2) activeStatuses.push('5');

          pendingJobs =
            !shift?.status_identity ||
            activeStatuses?.includes(String(shift?.status_identity));
        }

        if (pendingTasks || pendingCheckpointScans || pendingJobs) {
          pendingShifts.push(shift);
        }
      });

      resolve(pendingShifts);
    });
  }
  async openQueuedDialog(data: any[], showFrom = 'logout'): Promise<boolean> {
    const dialogRef = this.dialogService.open(QueuedEventsComponent, {
      data: { queuedResposeListData: data, showFrom: showFrom },
    });

    return await firstValueFrom(dialogRef.afterClosed());
  }
  async openPendingShiftDialog(): Promise<boolean> {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        message: 'You may have incomplete jobs',
        btn2Detail: { text: 'Ignore' },
      },
    });

    return await firstValueFrom(dialogRef.afterClosed());
  }
  async openClockOutDialog(
    earlyClockOut: boolean,
    onlyClockout = false,
  ): Promise<boolean> {
    const dialogRef = this.dialogService.open(
      this.clockInAndOutAdditionalInfoTemplate,
      {
        data: {
          header: onlyClockout
            ? earlyClockOut
              ? 'Early Clock Out'
              : 'Clock Out'
            : 'Sign Out',
          message: onlyClockout ? '' : 'This will also clock you out',
          needReason: earlyClockOut,
          placeholder: earlyClockOut ? 'Early clock out reason' : '',
        },
      },
      this.viewContainerRef,
    );

    return await firstValueFrom(dialogRef.afterClosed());
  }
  async handleHandoverLogs(): Promise<boolean> {
    const count = Number(sessionStorage.getItem('handOverLogDraftCount') || 0);

    if (count <= 0) return false;

    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Pending Handover Log',
        message: 'Review handover log.',
      },
    });

    const res = await firstValueFrom(dialogRef.afterClosed());

    this.navbarToggled = false;

    if (res) {
      this.router.navigate(['/add-hand-over-log']);
      return true; // stop logout flow
    }

    return false;
  }
  signOut() {
    this.spinnerService.show();
    if (this.isSuperUser === true) {
      this.appService.logOut();
    } else {
      let userData = this.appService.getUserData();

      this.profileService
        .logOut({ theme: userData?.preferences?.theme })
        .then((response: any) => {
          if (response?.status === 'success') {
            this.appService.logOut();
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
        });
    }
  }

  async handlePendingChecks(showFrom = 'logout'): Promise<{
    proceed: boolean;
  }> {
    // 1. Queued updates
    this.spinnerService.show('Checking for queued updates');
    const [queuedResposeListData] =
      await this.pageService.getSavedItemsInClientDb();

    this.spinnerService.hide();

    if (queuedResposeListData?.length) {
      const proceed = await this.openQueuedDialog(
        queuedResposeListData,
        showFrom,
      );
      if (!proceed) return { proceed: false };
    }

    // 2. Pending shifts
    this.spinnerService.show('Checking for pending shifts');
    const pendingShifts = (await this.checkForInCompleteShifts()) as [
      any[],
      any,
    ];
    this.spinnerService.hide();

    if (pendingShifts?.length) {
      const proceed = await this.openPendingShiftDialog();
      if (!proceed) return { proceed: false };
    }

    // 3. Handover logs
    const shouldNavigate = await this.handleHandoverLogs();
    if (shouldNavigate) return { proceed: false };

    return { proceed: true };
  }

  async onUserSignOut() {
    if (this.isSuperUser) {
      this.appService.logOut();
      return;
    }

    const { proceed } = await this.handlePendingChecks();
    if (!proceed) return;

    if (this.hasMultipleAccountsLinked) {
      this.openSwitchAccountTemplate(true);
    } else {
      this.signOut();
    }
  }

  async openSwitchAccountTemplate(logout = false) {
    this.switchAccountDialogOpened = true;
    const dialogRef = this.dialogService.open(MultipleAccountsComponent, {
      data: { logout },
    });

    const res = await firstValueFrom(dialogRef.afterClosed());
    this.switchAccountDialogOpened = false;
    if (!res) return;

    if (logout) {
      if (res === 'fullSignOut') this.signOut();
      else if (res?.id) this.changeAccount(res);
    } else {
      const { proceed } = await this.handlePendingChecks('multipleAccount');
      if (!proceed) return;

      // const clockOutSuccess = await this.handleClockOut(false, earlyClockOut);
      // if (!clockOutSuccess) return;

      if (res === 'fullSignOut') this.signOut();
      else if (res?.id) this.changeAccount(res);
    }
  }
  get screenWidth(): number {
    return window.innerWidth;
  }
  onBadgeClick(store: 'apple' | 'google', nativeAppDownloadTemplate: any) {
    const targetUrl =
      store === 'apple' ? 'https://apple.com' : 'https://google.com';
    if (this.largeView) {
      this.dialogService.open(
        nativeAppDownloadTemplate,
        {
          data: {
            src:
              store === 'apple'
                ? 'assets/native-app-logo/android-download-qr.avif'
                : 'assets/native-app-logo/ios-download-qr.avif',
          },
        },
        this.viewContainerRef,
      );
    } else {
      window.open(targetUrl, '_blank', 'noopener,noreferrer');
    }
  }
}
